app.controller('clientController', function ($rootScope, $scope, $element, $sce, $http, $location, $window, $routeParams, clientService, crmUploadsService, systemService, searchService, propertyService, safeApply, $filter, emailRepliesService, $sanitize) {

  const currentDate = new Date();
  const CurrentYear = currentDate.getFullYear();

  let initializing = true
  let userObjClone = null
  let sendHellosignDocs
  let cancelServiceOptions
  let modal_type = "email"
  let pendingCRMUploadTarget = null
  const appealChartInstances = {}

  function getDefaultChatsState() {
    return {
      loading: false,
      loaded: false,
      html: '',
      count: 0,
      error: null,
      stateFilter: 'open',
      newConversation: {
        open: false,
        sending: false,
        subject: '',
        body: ''
      }
    }
  }

  function getDefaultPaymentsState() {
    return {
      loading: false,
      loaded: false,
      error: null,
      payments: [],
      count: 0,
      total: 0
    }
  }

  $scope.documents_processing = false
  $scope.crmUploadsState = { uploading: false }
  $scope.additionalEmailsState = { loading: false, error: null, emails: [] }
  $scope.additionalEmailModal = { mode: 'add', title: '', saving: false, form: {} }
  $scope.authorizedUsersState = { loading: false, error: null, users: [], activity: [], activityLoading: false, activityError: null }
  $scope.authorizedUserModal = { mode: 'add', title: '', saving: false, form: {} }
  $scope.paymentsState = getDefaultPaymentsState()
  $scope.chatsState = getDefaultChatsState()
  $scope.chatLightbox = { open: false, src: '', alt: '' }
  $scope.importPropertiesForm = { cad_code: null, fee_structure_id: null, cad_accounts_text: '', validated: false, processing: false, properties: [] }
  $scope.importPropertyCountyList = []

  function getDefaultImportPropertyCadCode() {
    return $scope.importPropertyCountyList[0]?.cad_code || null
  }

  $scope.canValidateImportedProperties = function () {
    if ($scope.importPropertiesForm.processing) {
      return false
    }

    if ($scope.importPropertiesForm.validated) {
      return $scope.importPropertiesForm.properties.some(property => property.selected)
    }

    return !!($scope.importPropertiesForm.cad_code && $scope.importPropertiesForm.cad_accounts_text && $scope.importPropertiesForm.cad_accounts_text.trim().length)
  }

  $scope.validateImportedProperties = function () {
    if (!$scope.canValidateImportedProperties()) {
      return
    }

    if ($scope.importPropertiesForm.validated) {
      return
    }

    const cadAccounts = $scope.importPropertiesForm.cad_accounts_text
      .split(/\r?\n/)
      .map(item => item.trim())
      .filter(item => item.length > 0)

    $scope.importPropertiesForm.properties = cadAccounts.map(cadAccount => ({
      selected: true,
      cad_account: cadAccount,
      owner_name: '',
      situs_address: '',
      noticed_market: '',
      noticed_appraised: '',
      property_type: '',
      found: null
    }))
    $scope.importPropertiesForm.validated = true
  }

  $scope.submitImportProperties = async function () {
    if (!$scope.importPropertiesForm.validated) {
      $scope.validateImportedProperties()
      const selectedCadAccounts = $scope.importPropertiesForm.properties
        .filter(property => property.selected)
        .map(property => property.cad_account)

      if (!selectedCadAccounts.length) {
        toastr.error('Select at least one property to process.', 'Import Properties', { timeOut: 8000 })
        return
      }

      $scope.importPropertiesForm.processing = true

      try {
        const processImportedPropertiesResults = await propertyService.processImportedProperties({
          cad_code: $scope.importPropertiesForm.cad_code,
          cad_accounts: selectedCadAccounts
        })

        if (!processImportedPropertiesResults.data.success) {
          toastr.error('Unable to process imported properties.', 'Import Properties', { timeOut: 10000 })
          return
        }

        const processedProperties = new Map(
          processImportedPropertiesResults.data.data.map(property => [String(property.cad_account), property])
        )

        $scope.importPropertiesForm.properties = $scope.importPropertiesForm.properties.map(property => {
          if (!property.selected) {
            return property
          }

          const processedProperty = processedProperties.get(String(property.cad_account))
          if (!processedProperty) {
            return {
              ...property,
              selected: false,
              owner_name: '',
              situs_address: 'Not Found',
              noticed_market: '',
              noticed_appraised: '',
              property_type: '',
              found: false
            }
          }

          return {
            ...property,
            owner_name: processedProperty.owner_name,
            situs_address: processedProperty.situs_address,
            noticed_market: processedProperty.noticed_market,
            noticed_appraised: processedProperty.noticed_appraised,
            property_type: processedProperty.property_type,
            found: true
          }
        })

        const foundCount = $scope.importPropertiesForm.properties.filter(property => property.selected && property.found).length
        const missingCount = selectedCadAccounts.length - foundCount

        if (missingCount > 0) {
          toastr.warning(`${foundCount} properties found. ${missingCount} not found.`, 'Import Properties', { timeOut: 10000 })
        } else {
          toastr.success(`${foundCount} properties processed.`, 'Import Properties', { timeOut: 5000 })
        }
      } catch (error) {
        console.log('submitImportProperties -> error :>> ', error)
        toastr.error('Unexpected error processing imported properties.', 'Import Properties', { timeOut: 10000 })
      } finally {
        $scope.importPropertiesForm.processing = false
        safeApply($scope)
      }
      return
    }

    const selectedProperties = $scope.importPropertiesForm.properties.filter(property => property.selected && property.found)

    if (!selectedProperties.length) {
      toastr.error('Select at least one valid property to add.', 'Import Properties', { timeOut: 8000 })
      return
    }

    $scope.importPropertiesForm.processing = true

    try {
      let lastSuccessfulAddResult = null

      for (let index = 0; index < selectedProperties.length; index++) {
        const property = selectedProperties[index]
        const addPropertyToAccountResult = await propertyService.addPropertyToAccount({
          user_id: $scope.client.info.id,
          cad_code: $scope.importPropertiesForm.cad_code,
          cad_account: property.cad_account,
          fee_structure_id: $scope.importPropertiesForm.fee_structure_id,
          return_properties: index === selectedProperties.length - 1
        })

        if (!addPropertyToAccountResult.data.success) {
          toastr.error(`Unable to add property ${property.cad_account}.`, 'Import Properties', { timeOut: 10000 })
          return
        }

        lastSuccessfulAddResult = addPropertyToAccountResult
      }

      if (lastSuccessfulAddResult?.data?.data) {
        $scope.client.properties = lastSuccessfulAddResult.data.data
      }

      importPropertiesModal.hide()
      toastr.success(`${selectedProperties.length} properties added to account.`, 'Import Properties', { timeOut: 5000 })
    } catch (error) {
      console.log('submitImportProperties -> add error :>> ', error)
      toastr.error('Unexpected error adding imported properties.', 'Import Properties', { timeOut: 10000 })
    } finally {
      $scope.importPropertiesForm.processing = false
      safeApply($scope)
    }
  }

  $scope.handleBubblesClick = (event) => {
    const target = event?.target
    if (!target) return

    // Intercept "view attachment" links so the file opens inline in a new tab.
    const viewLink = target.closest && target.closest('[data-ic-view-attachment]')
    if (viewLink) {
      event.preventDefault()
      event.stopPropagation()
      const url = viewLink.getAttribute('data-ic-view-attachment')
      const contentType = viewLink.getAttribute('data-ic-content-type') || ''
      viewAttachmentInNewTab(url, contentType)
      return
    }

    if (target.tagName !== 'IMG') return
    if (!target.hasAttribute('data-ic-lightbox')) return
    event.preventDefault()
    event.stopPropagation()
    $scope.chatLightbox.src = target.getAttribute('src') || ''
    $scope.chatLightbox.alt = target.getAttribute('alt') || ''
    $scope.chatLightbox.open = true
    safeApply($scope)
  }

  async function viewAttachmentInNewTab(url, contentType) {
    if (!url) return
    // Open the tab synchronously so the popup blocker doesn't kill it during the await.
    const win = window.open('', '_blank')
    if (!win) {
      toastr.error('Browser blocked the popup. Allow popups for this site.', 'Attachment', { timeOut: 8000 })
      return
    }
    try {
      const response = await fetch(url)
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      const blob = await response.blob()
      const typedBlob = contentType ? new Blob([blob], { type: contentType }) : blob
      const blobUrl = URL.createObjectURL(typedBlob)
      win.location.href = blobUrl
      // Revoke after a delay so the new tab has time to load it.
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000)
    } catch (e) {
      console.log('viewAttachmentInNewTab-> error :>> ', e)
      // Fall back to direct navigation; browser may still force download but at least we tried.
      win.location.href = url
    }
  }

  $scope.closeChatLightbox = () => {
    $scope.chatLightbox.open = false
    $scope.chatLightbox.src = ''
    $scope.chatLightbox.alt = ''
  }

  const company = {
    "Residential": {
      route_url: "propertytax.io",
    },
    "TPTC": {
      route_url: "texasPTC.com",
    },
    "grc_tax": {
      route_url: "propertytax.io",
    }
  }

  // Select boxes - option data
  $scope.packages = {
    // '1': { name: 'None', value: 'u' },
    // '2': { name: 'Silver', value: 'silver' },
    '3': { name: 'Gold', value: 'gold' }
  }
  $scope.select_market_ue_options = [
    { name: 'Express', value: 'express' },
    { name: 'Custom', value: 'custom' },
    { name: 'Exclude', value: 'donotrun' },
  ]
  $scope.select_property_auth_method = {
    '0': { id: 0, name: 'None', value: 'none' },
    '1': { id: 1, name: 'Manual', value: 'manual' },
    '2': { id: 2, name: 'System', value: 'system' }
  }
  $scope.expiryOptions = {
    '1': { name: 'Will Notify', value: 'Until Cancelled' },
    '2': { name: `12/31/${CurrentYear}`, value: `12/31/${CurrentYear}` },
    '3': { name: `12/31/${CurrentYear + 1}`, value: `12/31/${CurrentYear + 1}` },
    '4': { name: `12/31/${CurrentYear + 2}`, value: `12/31/${CurrentYear + 2}` },
    '5': { name: `12/31/${CurrentYear + 3}`, value: `12/31/${CurrentYear + 3}` },
    '6': { name: `12/31/${CurrentYear + 4}`, value: `12/31/${CurrentYear + 4}` },
    '7': { name: `12/31/${CurrentYear + 5}`, value: `12/31/${CurrentYear + 5}` },
  }
  $scope.futureCancelRequestOptions = [
    { label: 'DO NOT CANCEL', value: null },
    { label: `Previous Year (${CurrentYear - 1})`, value: CurrentYear - 1 },
    { label: `This Year (${CurrentYear})`, value: CurrentYear },
    { label: `Next Year (${CurrentYear + 1})`, value: CurrentYear + 1 }
  ]

  $scope.data = {
    group1: '1',
    group2: '2',
    group3: '3'
  }

  // loadAppConfig()
  async function loadAppConfig() {
    let appConfigResults = await systemService.functionCall({ type: "loadAppConfig", items: "'agent_record', 'electronic_signature_test_mode'" })
    console.log('###### appConfigResults :>> ', appConfigResults);
    if (appConfigResults.data.success && appConfigResults.data.data.length > 0) {
      $scope.appConfiguration = {
        agent_record: appConfigResults.data.data[0].data,
        electronic_signature_test_mode: appConfigResults.data.data[1].data
      }
      console.log('$scope.appConfiguration :>> ', $scope.appConfiguration);
    } else {
      console.log("*** System Error ***")
    }
  }


  initController()

  // The property whose card is opened once its client loads - from the /prop/{prop_id} or /pid/... links,
  // or a Tax ID (#) / Prop ID (@) search. Cleared after that load, so later refreshes of the client
  // leave the cards as the user set them.
  let routePropId = $routeParams.prop_id ? String($routeParams.prop_id).trim() : null

  async function loadClientFromPropRouteParam() {
    if (!routePropId) return null
    const findResults = await clientService.findUserByPropID({ search: routePropId, exact: true })
    const owner = findResults?.data?.success && Array.isArray(findResults.data.data)
      ? findResults.data.data.find(row => String(row.prop_id) === routePropId && row.id)
      : null
    if (!owner || !owner.token || String(owner.token).trim().length === 0) {
      toastr.warning(`No client found for Prop ID ${routePropId}`, 'Property Not Found', { timeOut: 10000 })
      routePropId = null
      return null
    }
    const selectedClient = { record: { id: owner.id, token: owner.token } }
    clientService.setClientObj(selectedClient)
    return selectedClient
  }

  // /{user_id}/{url_password}/pid/{cad_code}/{cad_account} - the active properties with that CAD account.
  // One match opens like /prop/{prop_id}; several open the "Select Account" modal (cadAccountMatches).
  $scope.cadAccountRoute = $routeParams.cad_account
    ? { cad_code: String($routeParams.cad_code || '').trim(), cad_account: String($routeParams.cad_account).trim() }
    : null
  $scope.cadAccountMatches = []
  let cadAccountMatchesModal = null

  async function loadClientFromCadRouteParam() {
    const route = $scope.cadAccountRoute
    const findResults = await clientService.findUsersByCadAccount(route)
    const matches = findResults?.data?.success && Array.isArray(findResults.data.data)
      ? findResults.data.data.filter(row => row.id && row.token && String(row.token).trim().length > 0)
      : []

    if (matches.length === 0) {
      toastr.warning(`No active property found for CAD ${route.cad_code} / ${route.cad_account}`, 'Property Not Found', { timeOut: 10000 })
      return null
    }
    if (matches.length === 1) {
      routePropId = String(matches[0].prop_id)
      const selectedClient = { record: { id: matches[0].id, token: matches[0].token } }
      clientService.setClientObj(selectedClient)
      return selectedClient
    }

    // More than one account has it - let the user choose. Nothing loads until they do.
    $scope.cadAccountMatches = matches
    safeApply($scope)
    setTimeout(() => {
      cadAccountMatchesModal = new bootstrap.Modal(document.getElementById('cadAccountMatchesModal'))
      cadAccountMatchesModal.show()
    }, 0)
    return 'pending'
  }

  $scope.selectCadAccountMatch = (match) => {
    if (cadAccountMatchesModal) cadAccountMatchesModal.hide()
    routePropId = String(match.prop_id)
    clientService.setClientObj({ record: { id: match.id, token: match.token } })
    $scope.clientSearchSelected(match.id, match.token)
  }

  // Collapses every property card and opens the one for routePropId, then scrolls to it.
  function openRouteProperty() {
    if (!routePropId) return
    const propId = routePropId
    routePropId = null
    const index = ($scope.client.properties || []).findIndex(p => String(p.id) === propId)
    if (index === -1) {
      toastr.warning(`Prop ID ${propId} is not on this client's account`, 'Property Not Found', { timeOut: 10000 })
      return
    }
    // After the digest that rendered the ng-repeat, so the cards exist
    setTimeout(() => {
      $scope.allPropertiesExpandCollapse('collapse')
      const card = document.getElementById(`property_${index}`)
      if (!card) return
      card.classList.add('show')
      const header = card.previousElementSibling
      if (header) header.classList.remove('collapsed')
      card.closest('.property-box').scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 0)
  }

  async function loadClientFromRouteParam() {
    if ($scope.cadAccountRoute) return loadClientFromCadRouteParam()
    if (!$routeParams.target_user_id) return loadClientFromPropRouteParam()
    const targetUserId = String($routeParams.target_user_id).trim()
    if (!targetUserId.length) return null

    let routeClient = null

    const loadMergeDetailsResults = await clientService.loadMergeDetails({ user_id: targetUserId, token: '' })
    if (loadMergeDetailsResults?.data?.success && loadMergeDetailsResults?.data?.user?.id) {
      routeClient = loadMergeDetailsResults.data.user
    }

    if (!routeClient) {
      const findUserByAnyKeyResults = await clientService.findUserByAnyKey({ search: targetUserId })
      if (!findUserByAnyKeyResults.data.success || !Array.isArray(findUserByAnyKeyResults.data.data)) return null
      routeClient = findUserByAnyKeyResults.data.data.find(client => String(client.id) === targetUserId)
      if (!routeClient) return null
    }

    if (!routeClient.token || String(routeClient.token).trim().length === 0) return null

    const selectedClient = { record: { id: routeClient.id, token: routeClient.token } }
    clientService.setClientObj(selectedClient)
    return selectedClient
  }

  async function initController() {
    console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
    $scope.client = null

    setTimeout(() => {
      $scope.user = systemService.getUserObj($scope.user)
      console.log('$scope.user :>> ', $scope.user);
    }, 3000)

    // For the add route, initialize the client object up front (before the awaits
    // below) so the Client Only / PTIO radios render pre-selected on first bind.
    if (clientService.getClientMode() === 'clients_add') {
      userObjReset(1) // 1 = PropertyTax.io → defaults business_source to 'Residential' (PTIO)
    }

    await loadFeeStructures()
    await loadCountyList()
    switch (clientService.getClientMode()) {
      case 'clients_add':
        userObjReset(1) // 1 = PropertyTax.io → defaults business_source to 'Residential' (PTIO)
        safeApply($scope)
        break
      case 'clients_edit':
        if ($routeParams.target_user_id || $routeParams.prop_id || $scope.cadAccountRoute) {
          $scope.client = await loadClientFromRouteParam()
          // Waiting on the "Select Account" modal - stay in search mode until a client is picked
          if ($scope.client === 'pending') {
            $scope.client = null
            safeApply($scope)
            break
          }
        }

        if ($scope.client === null) {
          if ($location.$$host == 'localhost') {
            userObjReset()

            // $scope.client.record.id = 13488
            // $scope.client.record.token = 'd8jMqEPFbiRn4vmG0MH5EtKhhko2'

            // $scope.client.record.id = 6
            // $scope.client.record.token = 'ZcL02fugJ3QnVmRWgyCyRiYrrOK2'

            // $scope.client.record.id = 14398
            // $scope.client.record.token = 'L3AsBsdpJsNTy78BLxE2MozICORT'

          } else {
            $scope.client = clientService.getClientObj()
            // userObjReset() // Remove for Production
          }
        }
        if ($scope.client === null) {
          // Need to show search and stay in search mode till a client has been selected

        } else {
          // We have a client selected, so load it and put in edit mode.
          if ($scope.client.record.id > 0 && $scope.client.record.token.length > 20) {
            loadClientDetails()
          }
        }
        safeApply($scope)
        break
    }
    setTimeout(() => {
      $scope.initPopovers()
      initializing = false
      clipboard_js()
    }, 3000)
  }

  // Tax Ceilings Update - Tax Ceilings Tab
  $scope.createTaxCeilingsObj = async (p) => {
    let taxCeilingsResult = await propertyService.getTaxCeilings({ prop_id: p.id })
    console.log('taxCeilingsResult :>> ', taxCeilingsResult);
    if (taxCeilingsResult.data.success) {
      p.taxCeilingsOBJ = taxCeilingsResult.data.data
    } else {
      p.taxCeilingsOBJ = null
    }
    safeApply($scope)
  }
  $scope.updateTaxCeilings = async (p) => {
    let tax_ceilings = []
    p.taxCeilingsOBJ.tax_entities.map(t => {
      if (t.ceiling != null && t.ceiling !== '') tax_ceilings.push({ amount: t.ceiling, entity: t.code })
    })
    console.log('tax_ceilings :>> ', tax_ceilings);
    let taxCeilingsUpdateResult = await propertyService.updateTaxCeilings({ tax_ceilings: tax_ceilings, prop_id: p.id, tax_year: $rootScope.tax_year })
    console.log('taxCeilingsUpdateResult :>> ', taxCeilingsUpdateResult.data);
    if (taxCeilingsUpdateResult.data.success) {
      toastr.success("Tax Ceilings Updated", "Success!", { timeOut: 3000 })
    } else {
      toastr.error("Could NOT update Tax Ceilings", "Failed!", { timeOut: 10000 })
    }
    safeApply($scope)
  }
  // END:  Tax Ceilings Update - Tax Ceilings Tab

  // Exemptions Updates - Exemptions tab
  $scope.createExemptionObj = (p) => {
    let exemptions = { 'homestead': '', 'over_65': '', disabled: '', 'vet': false, 'vet_pct': '' }
    for (let i = 0; i < p.exemptions.length; i++) {
      if (p.exemptions[i] == 'homestead') { exemptions.homestead = 'homestead' }
      if (p.exemptions[i] == 'over_65') { exemptions.over_65 = 'over_65' }
      if (p.exemptions[i] == 'disabled') { exemptions.disabled = 'disabled' }
      if (p.exemptions[i] == 'dv1') { exemptions.vet = true; exemptions.vet_pct = 'dv1' }
      if (p.exemptions[i] == 'dv2') { exemptions.vet = true; exemptions.vet_pct = 'dv2' }
      if (p.exemptions[i] == 'dv3') { exemptions.vet = true; exemptions.vet_pct = 'dv3' }
      if (p.exemptions[i] == 'dv4') { exemptions.vet = true; exemptions.vet_pct = 'dv4' }
    }
    if (exemptions.homestead == '') exemptions = { 'homestead': '', 'over_65': '', disabled: '', 'vet': false, 'vet_pct': '' }
    p.exemptions_obj = exemptions
    safeApply($scope)
  }

  $scope.updateExemptions = async (p) => {
    let exemptions = []
    if (p.exemptions_obj.homestead == 'homestead') { exemptions.push('homestead') }
    if (p.exemptions_obj.over_65 == 'over_65') { exemptions.push('over_65') }
    if (p.exemptions_obj.disabled == 'disabled') { exemptions.push('disabled') }
    if (p.exemptions_obj.vet == false) {
      p.exemptions_obj.vet_pct = ''
    } else {
      exemptions.push(p.exemptions_obj.vet_pct)
    }
    if (p.exemptions_obj.homestead == '') exemptions = []
    // Update the property record with the new exemptions
    let obj = { prop_id: p.id, appeal_id: p.appeal_current.id, exemptions: exemptions, tax_year: p.appeal_current.tax_year }
    let updateExemptionsResults = await propertyService.updateExemptions(obj)
    if (updateExemptionsResults.data.success) {
      p.exemptions = exemptions   // Update the property record with the new exemptions
      toastr.success("Exemptions Updated", "Success!", { timeOut: 3000 })
    } else {
      toastr.error("Could NOT update exemptions", "Failed!", { timeOut: 10000 })
    }
    console.log('updateExemptionsResults :>> ', updateExemptionsResults);
    safeApply($scope)
  }
  $scope.vetExemptionToggle = (p) => {
    console.log('p.exemptions_obj.vet :>> ', p.exemptions_obj.vet);
    if (p.exemptions_obj.vet == false) p.exemptions_obj.vet_pct = ''
    if (p.exemptions_obj.vet == true) p.exemptions_obj.vet_pct = 'dv1'
  }
  // END:  Exemptions Updates - Exemptions tab


  // Show a "Copied!" tooltip that fades in/out near the clicked element.
  function showCopiedTooltip(triggerEl) {
    if (!triggerEl) return
    const tip = document.createElement('div')
    tip.className = 'cd-copied-tooltip'
    tip.textContent = 'Copied!'
    document.body.appendChild(tip)

    const rect = triggerEl.getBoundingClientRect()
    // Position centered above the trigger (fixed, so no scroll offset needed).
    tip.style.left = (rect.left + rect.width / 2) + 'px'
    tip.style.top = (rect.top - 8) + 'px'

    // Trigger fade-in on next frame, then fade out and remove.
    requestAnimationFrame(function () { tip.classList.add('cd-copied-tooltip--show') })
    setTimeout(function () { tip.classList.remove('cd-copied-tooltip--show') }, 1100)
    setTimeout(function () { if (tip.parentNode) tip.parentNode.removeChild(tip) }, 1500)
  }

  // https://clipboardjs.com/
  function clipboard_js() {
    let clipboard = new ClipboardJS('.fa-copy, .copyclipboard')
    let clipboard2 = new ClipboardJS('.copy-to-clipboard')

    clipboard.on('success', function (e) {
      showCopiedTooltip(e.trigger)
      e.clearSelection()
    })

    clipboard2.on('success', function (e) {
      // console.info('Action:', e.action)
      // console.info('Text:', e.text)
      // console.info('Trigger:', e.trigger)
      navigator.clipboard.writeText(e.text);
      showCopiedTooltip(e.trigger)
      e.clearSelection()
    })

  }

  let filterDropDown
  $scope.closePropertyFilter = function () {
    filterDropDown.hide()
    filterDropDown.dispose()
  }
  $scope.openPropertyFilter = function () {
    // filterDropDown = bootstrap.Dropdown.getOrCreateInstance("#report_options")
  }

  // Long-form label for a property's type code, shown in the property header pill.
  // Unknown codes fall back to the raw code so nothing is silently hidden.
  const PROP_TYPE_LABELS = { RES: 'Residential', COM: 'Commercial', BPP: 'Business Personal Property' }
  $scope.propTypeLabel = function (type) {
    const code = String(type || '').trim().toUpperCase()
    return PROP_TYPE_LABELS[code] || code
  }

  $scope.all_props_with_doc_links = function () {
    // Build a list of every property that currently has an unsigned document
    // request outstanding. Mirrors the per-property formatting used in client.prop_list.
    let unsigned_props = ''
    $scope.client.properties.map(item => {
      if (!item.docs_request) return
      const market = $filter('currency')(item.appeal_current.notified_market, "$", 0)
      const appraised = $filter('currency')(item.appeal_current.notified_appraised, "$", 0)
      const requestLink = item.docs_request.doc_link_request
      let statusLine = 'Documents Sent Not Signed'
      if (requestLink) statusLine += `\n   ${requestLink}`
      unsigned_props += `• ${item.situs.num} ${item.situs.street}, ${item.situs.city} - ${item.county} (${item.cad_account})\n   Market: ${market} | Appraised: ${appraised}\n   Prop ID: ${item.id}  | ${statusLine}\n\n`
    })

    let response = ''
    if (unsigned_props) {
      response = 'The following properties are waiting on documents to be signed, we cannot continue the Appeal Process until these are signed.\n\n' + unsigned_props
    } else {
      response = 'No properties currently have unsigned document links.\n'
    }

    $scope.copy_prop_list = $sce.trustAsHtml(response)
    safeApply($scope)
  }

  $scope.all_props_signup_status = function () {
    // if (initializing) return

    let response = ''
    let prop_list = 'I show you have the following properties in your account:\n\n'
    let pl_signed = 'The following properties have signed engagement documents:\n\n'
    let pl_unsigned = 'The following properties have NO signed engagement documents:\n\n'
    let pl_unsigned_props = ''
    let pl_signed_props = ''

    $scope.client.properties.map(item => {
      // Add evidence portal url to property list
      let co = company[$scope.client.info.business_source]
      item.evidence_portal_url = `https://wizardgold.${co.route_url}/${$scope.client.info.id}/${$scope.client.info.token}/${item.id}`

      let market = $filter('currency')(item.appeal_current.notified_market, "$", 0)
      let appraised = $filter('currency')(item.appeal_current.notified_appraised, "$", 0)

      if (item.auth_ptio == 1) {
        pl_signed_props += `• ${item.situs.num} ${item.situs.street}, ${item.situs.city} - ${item.county} (${item.cad_account})\n   Market: ${market} | Appraised: ${appraised}\n   Prop ID: ${item.id}\n\n`
      } else {
        pl_unsigned_props += `• ${item.situs.num} ${item.situs.street}, ${item.situs.city} - ${item.county} (${item.cad_account})\n   Market: ${market} | Appraised: ${appraised}\n   Prop ID: ${item.id}\n\n`
      }
    })

    response = prop_list
    if (pl_signed_props != '') response += pl_signed + pl_signed_props
    if (pl_unsigned_props != '') response += pl_unsigned + pl_unsigned_props

    $scope.copy_prop_list = $sce.trustAsHtml(response)
    safeApply($scope)
  }

  $scope.all_props_signup_status_fees = function () {
    return "HELLO WORLD 2"
  }

  $scope.allPropertiesExpandCollapse = function (action) {
    switch (action) {
      case 'expand':
        $('#property-list [id^="property_"]').addClass('show')
        $('.property-header').removeClass('collapsed')
        break
      case 'collapse':
        $('#property-list [id^="property_"]').removeClass('show')
        $('.property-header').addClass('collapsed')
        break
    }
  }

  let countyData = []
  async function loadCountyList() {
    let countyListResults = await systemService.functionCall({ type: "countyList", active_only: false })
    // console.log('countyListResults :>> ', countyListResults);
    if (countyListResults.data.success && countyListResults.data.data.length > 0) {
      countyData = countyListResults.data.data
      $scope.propertyCountyList = countyListResults.data.data
      $scope.importPropertyCountyList = countyListResults.data.data.filter(item => item.mapped_data == 1)
      if (!$scope.importPropertyCountyList.some(item => item.cad_code == $scope.importPropertiesForm.cad_code)) {
        $scope.importPropertiesForm.cad_code = getDefaultImportPropertyCadCode()
      }
      $scope.countyList = searchService.setGoogleCounties(countyListResults.data.data)
      // console.log('$scope.countyList :>> ', $scope.countyList);
    } else {
      console.log("*** System Error ***")
    }
  }

  async function loadFeeStructures() {
    const feeStructureResults = await systemService.functionCall({ type: "loadFeeStructures" })
    $scope.feeStructures = feeStructureResults.data.data.fee_structures
    $scope.feeDescriptions = feeStructureResults.data.data.fee_descriptions
    // console.log('$scope.feeStructures :>> ', JSON.stringify($scope.feeStructures, null, 2));
    console.log('$scope.feeStructures :>> ', $scope.feeStructures);
    // console.log('$scope.feeDescriptions :>> ', JSON.stringify($scope.feeDescriptions, null, 2));
    console.log('$scope.feeDescriptions :>> ', $scope.feeDescriptions);
  }

  // Fee Structure Dropdown ------------------------------------------------------------------------------

  // $scope.selectedFeeStructure = null
  // $scope.dropdownOpen = false

  // // Function to toggle dropdown
  // $scope.toggleDropdown = function () {
  //   $scope.dropdownOpen = !$scope.dropdownOpen
  // }

  // // Function to select a fee structure and close the menu
  // $scope.selectFeeStructure = function (fee_id) {
  //   console.log('fee_id :>> ', fee_id)
  //   // $scope.p.fee_structure_id = structure.id;
  //   // $scope.selectedFeeStructure = {
  //   //   fee_type_name: feeType.fee_type_name,
  //   //   description: structure.description
  //   // };
  //   $scope.dropdownOpen = false // Close the dropdown after selection
  // }

  // // Close dropdown when clicking outside
  // document.addEventListener('click', function (event) {
  //   var dropdown = document.querySelector('.fee-dropdown-container')
  //   if (!dropdown.contains(event.target)) {
  //     $scope.$apply(function () {
  //       $scope.dropdownOpen = false
  //     })
  //   }
  // })

  // ----------------------------------------------------------------------------------------------------

  $scope.initPopovers = function () {
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl, {
        trigger: 'hover',
        html: true,
        container: '#modal_body_id',
        customClass: 'popover-above-modal'
      })
    })
  }

  function destroyAppealChart(chartKey) {
    if (!appealChartInstances[chartKey]) return
    appealChartInstances[chartKey].destroy()
    delete appealChartInstances[chartKey]
  }

  function destroyAllAppealCharts() {
    Object.keys(appealChartInstances).forEach(destroyAppealChart)
  }

  function toAppealNumber(value) {
    const numericValue = Number(value)
    return Number.isFinite(numericValue) ? numericValue : 0
  }

  function compactCurrency(value) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      maximumFractionDigits: 1,
    }).format(toAppealNumber(value))
  }

  function exactCurrency(value) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(toAppealNumber(value))
  }

  function buildAppealChartData(property) {
    const appeals = []

    if (Array.isArray(property?.appeals_past)) {
      appeals.push(...property.appeals_past)
    }

    if (property?.appeal_current) {
      appeals.push(property.appeal_current)
    }

    const appealsByYear = new Map()
    appeals.forEach((appeal) => {
      const taxYear = Number(appeal?.tax_year)
      if (!Number.isFinite(taxYear)) return
      appealsByYear.set(taxYear, appeal)
    })

    return Array.from(appealsByYear.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([taxYear, appeal]) => ({
        tax_year: `${taxYear}`,
        notified_market: toAppealNumber(appeal?.notified_market),
        certified_market: toAppealNumber(appeal?.certified_market),
        notified_appraised: toAppealNumber(appeal?.notified_appraised),
        certified_appraised: toAppealNumber(appeal?.certified_appraised),
        tax_savings: toAppealNumber(appeal?.notified_tax?.total) - toAppealNumber(appeal?.certified_tax?.total),
      }))
  }

  function buildAppealChartSummary(chartData) {
    if (!Array.isArray(chartData) || !chartData.length) {
      return null
    }

    const latestYear = chartData[chartData.length - 1]
    const bestTaxSavingsItem = chartData.reduce((highest, item) => {
      return item.tax_savings > highest.tax_savings ? item : highest
    }, chartData[0])

    return {
      latest_market_change: compactCurrency(latestYear.notified_market - latestYear.certified_market),
      latest_appraised_change: compactCurrency(latestYear.notified_appraised - latestYear.certified_appraised),
      best_tax_savings: exactCurrency(bestTaxSavingsItem.tax_savings),
      best_tax_savings_year: bestTaxSavingsItem.tax_year,
    }
  }

  function createAppealChart(chartKey, canvasId, labels, datasets) {
    if (typeof Chart === 'undefined') return

    const canvas = document.getElementById(canvasId)
    if (!canvas) return

    destroyAppealChart(chartKey)

    const context = canvas.getContext('2d')
    appealChartInstances[chartKey] = new Chart(context, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: datasets,
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: 'index',
          intersect: false,
        },
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            beginAtZero: true,
            ticks: {
              callback: function (value) {
                return compactCurrency(value)
              },
            },
          },
        },
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              boxWidth: 12,
              usePointStyle: true,
            },
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return `${context.dataset.label}: ${exactCurrency(context.parsed.y)}`
              },
            },
          },
        },
      },
    })
  }

  function renderAppealCharts(property, index) {
    if (!property) return

    const chartData = property.appeal_chart_data || buildAppealChartData(property)
    if (!chartData.length) return

    setTimeout(() => {
      const labels = chartData.map((item) => item.tax_year)
      const baseBarOptions = {
        borderRadius: 4,
        maxBarThickness: 34,
      }

      createAppealChart(
        `market_${index}`,
        `appealMarketChart_${index}`,
        labels,
        [
          {
            label: 'Notified Market',
            data: chartData.map((item) => item.notified_market),
            backgroundColor: '#5b8def',
            ...baseBarOptions,
          },
          {
            label: 'Certified Market',
            data: chartData.map((item) => item.certified_market),
            backgroundColor: '#2bb3a3',
            ...baseBarOptions,
          },
        ]
      )

      createAppealChart(
        `appraised_${index}`,
        `appealAppraisedChart_${index}`,
        labels,
        [
          {
            label: 'Notified Appraised',
            data: chartData.map((item) => item.notified_appraised),
            backgroundColor: '#7c6ee6',
            ...baseBarOptions,
          },
          {
            label: 'Certified Appraised',
            data: chartData.map((item) => item.certified_appraised),
            backgroundColor: '#31a24c',
            ...baseBarOptions,
          },
        ]
      )

      createAppealChart(
        `savings_${index}`,
        `appealSavingsChart_${index}`,
        labels,
        [
          {
            label: 'Tax Savings',
            data: chartData.map((item) => item.tax_savings),
            backgroundColor: '#f3a43b',
            ...baseBarOptions,
          },
        ]
      )
    }, 150)
  }

  $scope.renderAppealCharts = (property, index) => {
    renderAppealCharts(property, index)
  }

  async function loadClientDetails() {
    destroyAllAppealCharts()
    let obj = { user_id: $scope.client.record.id, token: $scope.client.record.token }
    let loadClientDetailsResults = await clientService.loadClientDetails(obj)
    if (loadClientDetailsResults.data.success) {

      $scope.client.info = loadClientDetailsResults.data.data.info
      $scope.client.record = loadClientDetailsResults.data.data.record
      $scope.client.properties = loadClientDetailsResults.data.data.properties
      $scope.client.profile = loadClientDetailsResults.data.data.profile
      $scope.client.billing = loadClientDetailsResults.data.data.billing
      $scope.client.crm_upload_comment = ''
      $scope.client.crm_uploads = []
      $scope.chatsState = getDefaultChatsState()
      $scope.paymentsState = getDefaultPaymentsState()

      // used for copy to clipboard function
      let prop_list = 'I show you have the following properties in your account:\n\n'
      $scope.client.properties.map(item => {
        item.crm_upload_comment = ''
        item.crm_uploads = []
        item.future_cancel_request = item.future_cancel_request ? Number(item.future_cancel_request) : null
        item.appeal_chart_data = buildAppealChartData(item)
        item.appeal_chart_summary = buildAppealChartSummary(item.appeal_chart_data)

        // Create Exemption Object - Used to add/remove exemptions from property
        item.exemptions_db = item.exemptions
        $scope.createExemptionObj(item)

        // Add evidence portal url to property list
        let co = company[$scope.client.info.business_source]
        item.evidence_portal_url = `https://evidence.${co.route_url}/${$scope.client.info.id}/${$scope.client.info.token}/${item.id}`

        let market = $filter('currency')(item.appeal_current.notified_market, "$", 0)
        let appraised = $filter('currency')(item.appeal_current.notified_appraised, "$", 0)
        let package = ""

        switch (item.appeal_current.card_paid) {
          case 'gold':
            package = `GOLD Package`
            break
          case 'silver':
            package = `Silver Package`
            break
          default:
            package = `No Service Selected`
            break
        }

        // TEMP DEBUG: dump the document-related fields so we can see what's
        // actually present on the property object. Remove once status detection works.
        console.log('[prop_list debug] prop', item.id, {
          docs_current: item.docs_current,
          docs_request: item.docs_request,
          docs_keys: Object.keys(item).filter(k => k.toLowerCase().indexOf('doc') !== -1)
        })

        let statusLine = package
        const currentDocs = Array.isArray(item.docs_current) ? item.docs_current : []
        const hasSignedDoc = currentDocs.some(d => d && d.signed_on)
        if (hasSignedDoc) {
          statusLine = 'Signed up for Protection'
        } else if (item.docs_request) {
          statusLine = 'Documents Sent Not Signed'
          const requestLink = item.docs_request.doc_link_request
          if (requestLink) statusLine += `\n   ${requestLink}`
        }

        prop_list += `• ${item.situs.num} ${item.situs.street}, ${item.situs.city} - ${item.county} (${item.cad_account})\n   Market: ${market} | Appraised: ${appraised}\n   Prop ID: ${item.id}  | ${statusLine}\n\n`
      })
      $scope.client.prop_list = $sce.trustAsHtml(prop_list)

      await loadCRMUploads(false)
      await $scope.loadAdditionalEmails()
      await $scope.loadAuthorizedUsers()

      safeApply($scope)
      openRouteProperty()
      setTimeout(() => {
        $scope.initPopovers()
        clipboard_js()
        bindCRMUploadsInput()
      }, 1500)
      console.log('$scope.client :>> ', $scope.client)
    } else {
      toastr.error("There was an error loading Client Info", "Error Load Data!", { timeOut: 15000 })
    }
  }

  function bindCRMUploadsInput() {
    const fileInput = document.getElementById('crmUploadsInput')
    if (!fileInput) return

    fileInput.onchange = async (event) => {
      const selectedFiles = Array.from(event.target.files || [])
      event.target.value = ''
      if (!selectedFiles.length) return
      await uploadSelectedCRMFiles(selectedFiles)
    }
  }

  async function loadCRMUploads(showErrorMessage = false) {
    if (!$scope.client?.info?.id) return

    const getUploadsResults = await crmUploadsService.getUploadsByUser({ user_id: $scope.client.info.id })

    if (!getUploadsResults.data.success) {
      if (showErrorMessage) {
        toastr.error('Unable to load uploaded files.', 'CRM Uploads', { timeOut: 10000 })
      }
      return
    }

    const clientUploads = Array.isArray(getUploadsResults.data.data.client_uploads)
      ? getUploadsResults.data.data.client_uploads
      : []
    const propertyUploads = getUploadsResults.data.data.property_uploads || {}

    $scope.client.crm_uploads = clientUploads

    $scope.client.properties.forEach((property) => {
      property.crm_uploads = Array.isArray(propertyUploads[property.id])
        ? propertyUploads[property.id]
        : []
    })
  }

  function getCRMUploadComment(uploadTarget) {
    if (uploadTarget.upload_scope === 'client') {
      return `${$scope.client?.crm_upload_comment || ''}`.trim()
    }

    const property = $scope.client?.properties?.[uploadTarget.prop_index]
    return `${property?.crm_upload_comment || ''}`.trim()
  }

  function clearCRMUploadComment(uploadTarget) {
    if (uploadTarget.upload_scope === 'client') {
      $scope.client.crm_upload_comment = ''
      return
    }

    const property = $scope.client?.properties?.[uploadTarget.prop_index]
    if (property) {
      property.crm_upload_comment = ''
    }
  }

  async function uploadSelectedCRMFiles(selectedFiles) {
    if (!pendingCRMUploadTarget) return

    const uploadTarget = { ...pendingCRMUploadTarget }
    pendingCRMUploadTarget = null

    const formData = new FormData()
    formData.append('upload_scope', uploadTarget.upload_scope)
    formData.append('user_id', $scope.client.info.id)
    formData.append('comment', getCRMUploadComment(uploadTarget))
    formData.append('uploaded_by_initials', `${$scope.user?.initials || ''}`.trim())

    if (uploadTarget.upload_scope === 'property') {
      const property = $scope.client.properties[uploadTarget.prop_index]
      if (!property) {
        toastr.error('Property record not found for upload.', 'CRM Uploads', { timeOut: 10000 })
        return
      }
      formData.append('prop_id', property.id)
    }

    selectedFiles.forEach((file) => {
      formData.append('files', file)
    })

    $scope.crmUploadsState.uploading = true
    safeApply($scope)

    try {
      const uploadFilesResults = await crmUploadsService.uploadFiles(formData)
      const uploadedCount = uploadFilesResults?.data?.data?.uploaded?.length || 0
      const failedCount = uploadFilesResults?.data?.data?.failed?.length || 0

      if (!uploadFilesResults.data.success && uploadedCount === 0) {
        toastr.error('No files were uploaded.', 'CRM Uploads', { timeOut: 10000 })
        return
      }

      if (uploadedCount > 0 && failedCount === 0) {
        toastr.success(`${uploadedCount} file(s) uploaded.`, 'CRM Uploads', { timeOut: 5000 })
      } else if (uploadedCount > 0 && failedCount > 0) {
        toastr.warning(`${uploadedCount} file(s) uploaded and ${failedCount} failed.`, 'CRM Uploads', { timeOut: 10000 })
      } else {
        toastr.error(`${failedCount} file(s) failed to upload.`, 'CRM Uploads', { timeOut: 10000 })
      }

      clearCRMUploadComment(uploadTarget)
      await loadCRMUploads(true)
    } catch (error) {
      toastr.error('Unexpected error uploading files.', 'CRM Uploads', { timeOut: 10000 })
    } finally {
      $scope.crmUploadsState.uploading = false
      safeApply($scope)
    }
  }

  $scope.openCRMUploadDialog = (upload_scope, prop_index = null) => {
    if ($scope.crmUploadsState.uploading) return

    pendingCRMUploadTarget = { upload_scope: upload_scope, prop_index: prop_index }
    const fileInput = document.getElementById('crmUploadsInput')

    if (!fileInput) {
      toastr.error('Upload input is not available.', 'CRM Uploads', { timeOut: 10000 })
      return
    }

    fileInput.value = ''
    fileInput.click()
  }

  $scope.viewCRMUpload = (upload) => {
    if (!upload?.view_url) return
    $scope.route(upload.view_url, { open_new_tab: true })
  }

  $scope.downloadCRMUpload = (upload) => {
    if (!upload?.download_url) return
    $scope.route(upload.download_url, { open_new_tab: false })
  }

  $scope.editCRMUploadComment = async (upload) => {
    if (!upload?.id) return

    const modalTitle = upload.comment && upload.comment.trim().length > 0 ? 'Edit file comment' : 'Add file comment'

    const result = await Swal.fire({
      title: modalTitle,
      input: 'textarea',
      inputValue: upload.comment || '',
      inputPlaceholder: 'Enter a comment for this file',
      inputAttributes: {
        'aria-label': 'Enter a comment for this file'
      },
      showCancelButton: true,
      confirmButtonText: 'Save',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#6c757d'
    })

    if (!result.isConfirmed) return

    const updateUploadCommentResults = await crmUploadsService.updateUploadComment({
      upload_id: upload.id,
      comment: `${result.value || ''}`
    })

    if (!updateUploadCommentResults.data.success) {
      toastr.error('Unable to update file comment.', 'CRM Uploads', { timeOut: 10000 })
      return
    }

    await loadCRMUploads(true)
    toastr.success('File comment updated.', 'CRM Uploads', { timeOut: 5000 })
    safeApply($scope)
  }

  $scope.removeCRMUpload = (upload) => {
    if (!upload?.id) return

    swal.fire({
      title: 'Remove file?',
      text: upload.original_file_name,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, remove it'
    }).then(async (result) => {
      if (!result.isConfirmed) return

      const deleteUploadResults = await crmUploadsService.deleteUpload({ upload_id: upload.id })
      if (!deleteUploadResults.data.success) {
        toastr.error('Unable to remove file.', 'CRM Uploads', { timeOut: 10000 })
        return
      }

      await loadCRMUploads(true)
      toastr.success('File removed.', 'CRM Uploads', { timeOut: 5000 })
      safeApply($scope)
    })
  }

  $scope.formatCRMFileSize = (fileSize) => {
    let size = Number(fileSize || 0)
    if (size <= 0) return '0 B'

    const units = ['B', 'KB', 'MB', 'GB', 'TB']
    let unitIndex = 0

    while (size >= 1024 && unitIndex < units.length - 1) {
      size = size / 1024
      unitIndex += 1
    }

    const decimals = size >= 10 || unitIndex === 0 ? 0 : 1
    return `${size.toFixed(decimals)} ${units[unitIndex]}`
  }

  $scope.gotoChat = (target) => {
    const total = ($scope.chatsState.conversations || []).length
    if (total === 0) return
    const previousConversation = $scope.chatsState.currentConv
    let idx = $scope.chatsState.currentIndex
    if (target === 'first') idx = 0
    else if (target === 'last') idx = total - 1
    else if (target === 'prev') idx = Math.max(0, idx - 1)
    else if (target === 'next') idx = Math.min(total - 1, idx + 1)
    else if (typeof target === 'number') idx = Math.max(0, Math.min(total - 1, target))
    if (previousConversation && previousConversation !== $scope.chatsState.conversations[idx]) {
      destroyIntercomReplyEditor(previousConversation)
    }
    $scope.chatsState.currentIndex = idx
    $scope.chatsState.currentConv = $scope.chatsState.conversations[idx]
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const el = document.getElementById('ic-chats-bubbles')
        if (el) el.scrollTop = el.scrollHeight
      })
    })
    // Attach Summernote to the now-visible reply textarea (next digest cycle).
    setTimeout(() => initIntercomReplyEditor($scope.chatsState.currentConv), 0)
  }

  $scope.chatsPageNumbers = () => {
    const total = ($scope.chatsState.conversations || []).length
    const current = $scope.chatsState.currentIndex || 0
    if (total <= 1) return []
    const window_size = 5
    let start = Math.max(0, current - 2)
    let end = Math.min(total, start + window_size)
    start = Math.max(0, end - window_size)
    const pages = []
    for (let i = start; i < end; i++) pages.push(i)
    return pages
  }

  $scope.onChatsTabSelected = () => {
    if ($scope.chatsState.loading) return
    if (!$scope.chatsState.loaded) {
      $scope.chatsState.stateFilter = 'open'
    }
    // Always refetch when the user clicks the Chats tab so they see fresh data
    // — auto-poll is paused while the tab is inactive, so state could be stale.
    $scope.loadChats()
    // Reset the countdown ring so it starts a fresh 30s window from this moment.
    if (typeof restartIntercomRingAnimation === 'function') {
      restartIntercomRingAnimation()
    }
  }

  // Payments tab - lazy loaded the first time the tab is opened, then refreshed
  // on each click so a payment entered elsewhere shows up.
  $scope.onPaymentsTabSelected = () => {
    if ($scope.paymentsState.loading) return
    $scope.loadClientPayments()
  }

  $scope.loadClientPayments = async () => {
    const user_id = $scope.client?.info?.id
    if (!user_id) {
      $scope.paymentsState.error = 'No client record loaded.'
      safeApply($scope)
      return
    }
    if ($scope.paymentsState.loading) return

    $scope.paymentsState.loading = true
    $scope.paymentsState.error = null
    safeApply($scope)

    try {
      const result = await clientService.getClientPayments({ user_id: user_id })
      if (!result?.data?.success) {
        $scope.paymentsState.error = 'Unable to load payments for this client.'
        toastr.error($scope.paymentsState.error, 'Payments', { timeOut: 10000 })
        return
      }
      const rows = result.data.data || []
      $scope.paymentsState.payments = rows
      $scope.paymentsState.count = rows.length
      // Refunds and past-due penalties add to the balance; everything else credits it.
      $scope.paymentsState.total = rows.reduce((sum, r) => sum + Number(r.payment_amount || 0), 0)
      $scope.paymentsState.loaded = true
    } catch (error) {
      console.log('loadClientPayments error :>> ', error)
      $scope.paymentsState.error = 'Payments request failed before completion.'
      toastr.error($scope.paymentsState.error, 'Payments', { timeOut: 10000 })
    } finally {
      $scope.paymentsState.loading = false
      safeApply($scope)
    }
  }

  // Additional Emails tab - the client's z_users_emails rows, same as the
  // Dashboard's "Edit Profile" > Additional Email Addresses section.
  $scope.loadAdditionalEmails = async () => {
    const user_id = $scope.client?.info?.id
    if (!user_id) return

    $scope.additionalEmailsState.loading = true
    $scope.additionalEmailsState.error = null
    safeApply($scope)

    try {
      const result = await clientService.getAdditionalEmails({ user_id: user_id })
      if (!result?.data?.success) {
        $scope.additionalEmailsState.emails = []
        $scope.additionalEmailsState.error = 'Unable to load additional emails for this client.'
        return
      }
      $scope.additionalEmailsState.emails = result.data.data || []
    } catch (error) {
      console.log('loadAdditionalEmails error :>> ', error)
      $scope.additionalEmailsState.emails = []
      $scope.additionalEmailsState.error = 'Additional emails request failed before completion.'
    } finally {
      $scope.additionalEmailsState.loading = false
      safeApply($scope)
    }
  }

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(`${email || ''}`.trim())

  $scope.openAdditionalEmailModal = (mode, email) => {
    $scope.additionalEmailModal.mode = mode
    $scope.additionalEmailModal.saving = false
    if (mode === 'add') {
      $scope.additionalEmailModal.title = 'Add Additional Email'
      $scope.additionalEmailModal.form = { first_name: '', last_name: '', email: '', notices: 1, invoices: 1, newsletter: 0, blog_post: 0 }
    } else {
      $scope.additionalEmailModal.title = 'Edit Email Address'
      $scope.additionalEmailModal.form = angular.copy(email)
    }
    bootstrap.Modal.getOrCreateInstance(document.getElementById('additionalEmailModal')).show()
  }

  $scope.saveAdditionalEmail = async () => {
    const form = $scope.additionalEmailModal.form
    if (!form.first_name || form.first_name.trim().length < 2) {
      toastr.error('First name must be at least 2 characters.', 'Additional Emails')
      return
    }
    if (!form.last_name || form.last_name.trim().length < 2) {
      toastr.error('Last name must be at least 2 characters.', 'Additional Emails')
      return
    }
    if (!isValidEmail(form.email)) {
      toastr.error('Please enter a valid email address.', 'Additional Emails')
      return
    }

    const isAdd = $scope.additionalEmailModal.mode === 'add'
    const obj = { ...form, user_id: $scope.client.info.id }

    $scope.additionalEmailModal.saving = true
    safeApply($scope)

    try {
      const result = isAdd
        ? await clientService.addAdditionalEmail(obj)
        : await clientService.updateAdditionalEmail(obj)
      if (!result?.data?.success) {
        toastr.error(`Failed to ${isAdd ? 'add' : 'update'} email.`, 'Additional Emails', { timeOut: 10000 })
        return
      }
      bootstrap.Modal.getOrCreateInstance(document.getElementById('additionalEmailModal')).hide()
      toastr.success(`Email ${isAdd ? 'added' : 'updated'}.`, 'Additional Emails', { timeOut: 5000 })
      await $scope.loadAdditionalEmails()
    } catch (error) {
      console.log('saveAdditionalEmail error :>> ', error)
      toastr.error('Error saving email.', 'Additional Emails', { timeOut: 10000 })
    } finally {
      $scope.additionalEmailModal.saving = false
      safeApply($scope)
    }
  }

  $scope.updateAdditionalEmailToggle = async (email, field) => {
    try {
      const result = await clientService.updateAdditionalEmail({
        id: email.id,
        user_id: $scope.client.info.id,
        field: field,
        value: email[field]
      })
      if (!result?.data?.success) throw new Error(result?.data?.error || 'Update failed')
      toastr.success('Email preference updated.', 'Additional Emails', { timeOut: 3000 })
    } catch (error) {
      console.log('updateAdditionalEmailToggle error :>> ', error)
      toastr.error('Error updating email preference.', 'Additional Emails', { timeOut: 10000 })
      // Revert the switch so it matches what's saved
      email[field] = email[field] == 1 ? 0 : 1
      safeApply($scope)
    }
  }

  $scope.removeAdditionalEmail = (email) => {
    if (!email?.id) return

    swal.fire({
      title: 'Remove email address?',
      text: email.email,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, remove it'
    }).then(async (result) => {
      if (!result.isConfirmed) return

      const deleteResults = await clientService.deleteAdditionalEmail({ id: email.id, user_id: $scope.client.info.id })
      if (!deleteResults?.data?.success) {
        toastr.error('Unable to remove email address.', 'Additional Emails', { timeOut: 10000 })
        return
      }

      await $scope.loadAdditionalEmails()
      toastr.success('Email address removed.', 'Additional Emails', { timeOut: 5000 })
    })
  }

  // Authorized Users tab - people other than the owner who can sign in to this account
  // (z_users_authorized), the same list the owner manages from the Dashboard's Edit Profile.
  // Staff never see or set passwords: people set their own from an emailed link.
  const AUTHORIZED_ERRORS = {
    EMAIL_IN_USE: 'That email address is already used to sign in to an account.',
    THROTTLED: 'An email was just sent to this person. Please wait a couple of minutes before sending another.',
    EMAIL_FAILED: 'The email could not be sent.'
  }
  const authorizedError = (result, fallback) => {
    const err = result?.data?.error
    if (typeof err === 'string') return AUTHORIZED_ERRORS[err] || err
    return fallback
  }

  $scope.loadAuthorizedUsers = async () => {
    const user_id = $scope.client?.info?.id
    if (!user_id) return

    $scope.authorizedUsersState.loading = true
    $scope.authorizedUsersState.error = null
    safeApply($scope)

    try {
      const result = await clientService.getAuthorizedUsers({ user_id: user_id })
      if (!result?.data?.success) {
        $scope.authorizedUsersState.users = []
        $scope.authorizedUsersState.error = 'Unable to load authorized users for this client.'
        return
      }
      $scope.authorizedUsersState.users = result.data.data || []
    } catch (error) {
      console.log('loadAuthorizedUsers error :>> ', error)
      $scope.authorizedUsersState.users = []
      $scope.authorizedUsersState.error = 'Authorized users request failed before completion.'
    } finally {
      $scope.authorizedUsersState.loading = false
      safeApply($scope)
    }
    $scope.loadAuthorizedUserActivity()
  }

  $scope.loadAuthorizedUserActivity = async () => {
    const user_id = $scope.client?.info?.id
    if (!user_id) return
    $scope.authorizedUsersState.activityLoading = true
    $scope.authorizedUsersState.activityError = null
    safeApply($scope)
    try {
      const result = await clientService.getAuthorizedUserActivity({ user_id: user_id })
      if (!result?.data?.success) {
        $scope.authorizedUsersState.activity = []
        $scope.authorizedUsersState.activityError = 'Unable to load recent activity.'
        return
      }
      $scope.authorizedUsersState.activity = (result.data.data || []).map(describeActivity)
    } catch (error) {
      console.log('loadAuthorizedUserActivity error :>> ', error)
      $scope.authorizedUsersState.activity = []
      $scope.authorizedUsersState.activityError = 'Recent activity request failed before completion.'
    } finally {
      $scope.authorizedUsersState.activityLoading = false
      safeApply($scope)
    }
  }

  // One z_activity_logs row -> { when, who, what, detail } for the Recent activity list
  function describeActivity(row) {
    let log = row.log
    if (typeof log === 'string') { try { log = JSON.parse(log) } catch (e) { log = {} } }
    log = log || {}
    const d = log.details || {}

    let who
    if (row.actor_type === 'authorized') who = `${row.authorized_name || log.actor?.name || 'Authorized user'} (authorized user)`
    else if (row.actor_type === 'owner') who = 'Owner'
    else if (row.actor_type === 'staff' || (!row.actor_type && row.source === 'CRM')) who = `Staff (${row.operator || '?'})`
    else if (row.actor_type === 'system') who = 'System'
    else if (log.actor_missing) who = 'Unknown (no session)'
    else who = row.source || 'System'   // older rows written before people were recorded

    const parts = []
    if (d.authorized_user) parts.push(`${d.authorized_user.name || ''} ${d.authorized_user.email ? '<' + d.authorized_user.email + '>' : ''}`.trim())
    if (d.amount != null) parts.push(`$${Number(d.amount).toFixed(2)}`)
    if (d.prop_id) parts.push(`Prop ${d.prop_id}`)
    if (d.method) parts.push(d.method)
    if (d.new_email) parts.push(d.new_email)
    if (Array.isArray(d.authorized_users)) parts.push(d.authorized_users.map(p => p.name).join(', '))
    if (d.success === false) parts.push(`FAILED${d.error ? ': ' + d.error : ''}`)

    return {
      id: row.id,
      when: row.createdAT,
      source: row.source,
      who: who,
      what: (row.type || '').replace(/_/g, ' ').toLowerCase().replace(/^\w/, c => c.toUpperCase()),
      detail: parts.filter(Boolean).join(' · '),
      failed: d.success === false
    }
  }

  // Status shown in the table
  $scope.authorizedUserStatus = (au) => {
    if (au.status === 'invited') {
      if (!au.link_sent_at) return 'Invitation not sent'
      return au.invite_expired == 1 ? 'Invitation expired' : 'Invitation sent'
    }
    if (au.status === 'active') return 'Active'
    if (au.status === 'disabled') return 'Access off'
    return au.status
  }

  $scope.openAuthorizedUserModal = (mode, au) => {
    $scope.authorizedUserModal.mode = mode
    $scope.authorizedUserModal.saving = false
    if (mode === 'add') {
      $scope.authorizedUserModal.title = 'Add Authorized User'
      $scope.authorizedUserModal.form = { first_name: '', last_name: '', email: '', also_receive_emails: false }
    } else {
      $scope.authorizedUserModal.title = 'Edit Authorized User'
      $scope.authorizedUserModal.form = { id: au.id, first_name: au.first_name, last_name: au.last_name, email: au.email }
    }
    // clear a leftover "already used" flag from the last time the modal was open
    if ($scope.authorizedUserForm && $scope.authorizedUserForm.au_email) $scope.authorizedUserForm.au_email.$setValidity('unique', true)
    bootstrap.Modal.getOrCreateInstance(document.getElementById('authorizedUserModal')).show()
  }

  $scope.saveAuthorizedUser = async () => {
    const form = $scope.authorizedUserModal.form
    const isAdd = $scope.authorizedUserModal.mode === 'add'
    if (!form.first_name || !form.first_name.trim() || !form.last_name || !form.last_name.trim()) {
      toastr.error('First and last name are required.', 'Authorized Users')
      return
    }
    if (isAdd && !isValidEmail(form.email)) {
      toastr.error('Please enter a valid email address.', 'Authorized Users')
      return
    }

    $scope.authorizedUserModal.saving = true
    safeApply($scope)
    try {
      const obj = { ...form, user_id: $scope.client.info.id, operator_id: $scope.user.initials }
      const result = isAdd
        ? await clientService.addAuthorizedUser(obj)
        : await clientService.updateAuthorizedUser(obj)
      if (!result?.data?.success) {
        toastr.error(authorizedError(result, `Failed to ${isAdd ? 'add' : 'update'} authorized user.`), 'Authorized Users', { timeOut: 10000 })
        return
      }
      bootstrap.Modal.getOrCreateInstance(document.getElementById('authorizedUserModal')).hide()
      if (isAdd && result.data.warning) {
        toastr.warning('Added, but the invitation email could not be sent. Use "Resend Invite".', 'Authorized Users', { timeOut: 12000 })
      } else {
        toastr.success(isAdd ? `Invitation sent to ${form.email}. The owner has been notified.` : 'Authorized user updated.', 'Authorized Users', { timeOut: 6000 })
      }
      await $scope.loadAuthorizedUsers()
      if (isAdd && result.data.additional_email_added) await $scope.loadAdditionalEmails()
    } catch (error) {
      console.log('saveAuthorizedUser error :>> ', error)
      toastr.error('Error saving authorized user.', 'Authorized Users', { timeOut: 10000 })
    } finally {
      $scope.authorizedUserModal.saving = false
      safeApply($scope)
    }
  }

  // action: resend_invite | send_reset | unlock | disable | enable | remove
  $scope.authorizedUserAction = (action, au) => {
    if (!au?.id) return
    const name = `${au.first_name} ${au.last_name}`
    const confirmations = {
      resend_invite: { title: 'Resend invitation?', text: `A new invitation link will be emailed to ${au.email}. Any earlier link stops working.`, button: 'Yes, resend' },
      send_reset: { title: 'Send password reset?', text: `A password reset link (valid 2 hours) will be emailed to ${au.email}.`, button: 'Yes, send it' },
      unlock: { title: 'Unlock sign in?', text: `${name} will be able to try their password again right away.`, button: 'Yes, unlock' },
      disable: { title: 'Turn off access?', text: `${name} will be signed out and won't be able to sign in. The owner will be emailed.`, button: 'Yes, turn off' },
      enable: { title: 'Turn access back on?', text: `${name} will be able to sign in again. The owner will be emailed.`, button: 'Yes, turn on' },
      remove: { title: 'Remove authorized user?', text: `${name} (${au.email}) will be signed out and removed from this account. The owner will be emailed.`, button: 'Yes, remove' }
    }
    const c = confirmations[action]
    if (!c) return
    const danger = action === 'disable' || action === 'remove'

    swal.fire({
      title: c.title,
      text: c.text,
      icon: danger ? 'warning' : 'question',
      showCancelButton: true,
      confirmButtonColor: danger ? '#d33' : '#3085d6',
      cancelButtonColor: '#6c757d',
      confirmButtonText: c.button
    }).then(async (choice) => {
      if (!choice.isConfirmed) return
      const obj = { id: au.id, user_id: $scope.client.info.id, operator_id: $scope.user.initials }
      let result
      try {
        switch (action) {
          case 'resend_invite': result = await clientService.resendAuthorizedUserInvite(obj); break
          case 'send_reset': result = await clientService.sendAuthorizedUserReset(obj); break
          case 'unlock': result = await clientService.unlockAuthorizedUser(obj); break
          case 'disable': result = await clientService.setAuthorizedUserStatus({ ...obj, status: 'disabled' }); break
          case 'enable': result = await clientService.setAuthorizedUserStatus({ ...obj, status: 'active' }); break
          case 'remove': result = await clientService.removeAuthorizedUser(obj); break
        }
      } catch (error) {
        console.log('authorizedUserAction error :>> ', error)
      }
      if (!result?.data?.success) {
        toastr.error(authorizedError(result, 'The change could not be saved.'), 'Authorized Users', { timeOut: 10000 })
        return
      }
      toastr.success({
        resend_invite: 'Invitation sent.', send_reset: 'Password reset email sent.', unlock: 'Sign in unlocked.',
        disable: 'Access turned off.', enable: 'Access turned back on.', remove: 'Authorized user removed.'
      }[action], 'Authorized Users', { timeOut: 5000 })
      await $scope.loadAuthorizedUsers()
    })
  }

  function getChatRecipientEmail() {
    return ($scope.client?.info?.email || $scope.client?.record?.email || $scope.client?.profile?.email || '').toString().trim()
  }

  function getChatRecipientName() {
    const fullName = `${$scope.client?.info?.first_name || ''} ${$scope.client?.info?.last_name || ''}`.trim()
    return fullName || getChatRecipientEmail()
  }

  function resetNewConversationForm() {
    destroyIntercomNewConversationEditor()
    $scope.chatsState.newConversation = {
      open: false,
      sending: false,
      subject: '',
      body: ''
    }
  }

  // Shared Summernote toolbar/options for the Intercom composers (new conversation + inline reply).
  const intercomEditorOptions = {
    placeholder: '',
    tabsize: 2,
    height: 220,
    dialogsInBody: true,
    toolbar: [
      ['style', ['style']],
      ['font', ['bold', 'italic', 'strikethrough', 'clear']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['insert', ['link', 'hr']],
      ['view', ['codeview']]
    ]
  }

  function normalizeIntercomBody(content) {
    const value = String(content || '').trim()
    if (!value || value === '<p><br></p>' || value === '<br>') return ''
    return value
  }

  let intercomNewConversationEditorReady = false
  function initIntercomNewConversationEditor() {
    const element = $('#intercom_new_conversation_body')
    if (!element.length || !$.fn.summernote) return
    if (intercomNewConversationEditorReady) {
      element.summernote('code', $scope.chatsState.newConversation.body || '')
      return
    }
    element.summernote({
      ...intercomEditorOptions,
      placeholder: 'Type your message to the customer...',
      callbacks: {
        onChange: function (contents) {
          $scope.chatsState.newConversation.body = normalizeIntercomBody(contents)
          safeApply($scope)
        }
      }
    })
    element.summernote('code', $scope.chatsState.newConversation.body || '')
    intercomNewConversationEditorReady = true
  }

  function destroyIntercomNewConversationEditor() {
    const element = $('#intercom_new_conversation_body')
    if (intercomNewConversationEditorReady && element.length && $.fn.summernote) {
      element.summernote('destroy')
    }
    intercomNewConversationEditorReady = false
  }

  // Summernote's onChange does NOT fire reliably for every toolbar action (color picker,
  // font size, and some style menus emit no event until the next keystroke). Always
  // pull the live HTML directly from the editor at send time to avoid losing formatting.
  function syncIntercomNewConversationFromEditor() {
    const element = $('#intercom_new_conversation_body')
    if (intercomNewConversationEditorReady && element.length && $.fn.summernote) {
      $scope.chatsState.newConversation.body = normalizeIntercomBody(element.summernote('code'))
    }
    return $scope.chatsState.newConversation.body || ''
  }

  function syncIntercomReplyFromEditor(conversation) {
    if (!conversation || !conversation.composer) return ''
    if (conversation.composer.type === 'note') return conversation.composer.text || ''
    const element = $('#' + intercomReplyEditorId(conversation))
    if (conversation.composer.editorReady && element.length && $.fn.summernote) {
      conversation.composer.text = normalizeIntercomBody(element.summernote('code'))
    }
    return conversation.composer.text || ''
  }

  // ---------------------------------------------------------------------------
  // Reply attachments — Intercom's reply endpoint accepts up to 10 files via
  // attachment_files: [{ name, content_type, file_data (base64) }]. We support
  // file-picker, drag-drop, and image paste (paste/drop into the editor body
  // becomes an attachment, not an inline data URL — Intercom strips data URLs).
  // ---------------------------------------------------------------------------
  const INTERCOM_REPLY_MAX_ATTACHMENTS = 10

  function ensureAttachmentsArray(conversation) {
    if (!conversation || !conversation.composer) return null
    if (!Array.isArray(conversation.composer.attachments)) {
      conversation.composer.attachments = []
    }
    return conversation.composer.attachments
  }

  function readFileAsBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => {
        const result = String(reader.result || '')
        const commaIndex = result.indexOf(',')
        resolve(commaIndex >= 0 ? result.slice(commaIndex + 1) : result)
      }
      reader.onerror = () => reject(reader.error || new Error('FileReader failed'))
      reader.readAsDataURL(file)
    })
  }

  $scope.addReplyAttachments = async (conversation, fileList) => {
    const attachments = ensureAttachmentsArray(conversation)
    if (!attachments) return
    const files = Array.from(fileList || [])
    if (!files.length) return

    for (const file of files) {
      if (attachments.length >= INTERCOM_REPLY_MAX_ATTACHMENTS) {
        toastr.warning(`Max ${INTERCOM_REPLY_MAX_ATTACHMENTS} attachments per reply.`, 'Intercom Chats', { timeOut: 6000 })
        break
      }
      const entry = {
        id: `att_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
        name: file.name || 'attachment',
        size: file.size || 0,
        content_type: file.type || 'application/octet-stream',
        status: 'reading',
        file_data: ''
      }
      attachments.push(entry)
      safeApply($scope)
      try {
        entry.file_data = await readFileAsBase64(file)
        entry.status = 'ready'
      } catch (error) {
        console.log('addReplyAttachments-> read error :>> ', error)
        entry.status = 'error'
        entry.error = (error && error.message) || 'Read failed'
        toastr.error(`Could not read ${entry.name}.`, 'Intercom Chats', { timeOut: 6000 })
      }
      safeApply($scope)
    }
  }

  $scope.removeReplyAttachment = (conversation, attachmentId) => {
    const attachments = ensureAttachmentsArray(conversation)
    if (!attachments) return
    const index = attachments.findIndex(a => a.id === attachmentId)
    if (index >= 0) attachments.splice(index, 1)
    safeApply($scope)
  }

  // Single shared hidden file input (#intercomReplyAttachInput) is bound once and
  // routes selected files to whichever conversation last opened the picker.
  let pendingIntercomReplyTarget = null

  function bindIntercomReplyAttachInput() {
    const fileInput = document.getElementById('intercomReplyAttachInput')
    if (!fileInput || fileInput._intercomBound) return
    fileInput.onchange = async (event) => {
      const selectedFiles = Array.from(event.target.files || [])
      event.target.value = ''
      const target = pendingIntercomReplyTarget
      pendingIntercomReplyTarget = null
      if (!target || !selectedFiles.length) return
      await $scope.addReplyAttachments(target, selectedFiles)
    }
    fileInput._intercomBound = true
  }

  $scope.openReplyAttachPicker = (conversation) => {
    bindIntercomReplyAttachInput()
    const fileInput = document.getElementById('intercomReplyAttachInput')
    if (!fileInput) {
      toastr.error('File picker is not available.', 'Intercom Chats', { timeOut: 6000 })
      return
    }
    pendingIntercomReplyTarget = conversation
    fileInput.click()
  }

  $scope.handleNoteKeydown = (conversation, event) => {
    if (!event || event.key !== 'Enter') return
    if (!(event.ctrlKey || event.metaKey)) return
    event.preventDefault()
    if ($scope.canSendChatMessage(conversation)) {
      $scope.sendChatMessage(conversation)
    }
  }

  $scope.formatAttachmentSize = (bytes) => {
    const n = Number(bytes) || 0
    if (n < 1024) return `${n} B`
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`
    return `${(n / 1024 / 1024).toFixed(1)} MB`
  }

  // Per-conversation reply editor lifecycle.
  function intercomReplyEditorId(conversation) {
    return `intercom_reply_body_${conversation?.id || 'unknown'}`
  }

  function initIntercomReplyEditor(conversation) {
    if (!conversation || !conversation.composer) return
    if (conversation.composer.type === 'note') {
      destroyIntercomReplyEditor(conversation)
      return
    }
    const element = $('#' + intercomReplyEditorId(conversation))
    if (!element.length || !$.fn.summernote) return
    if (conversation.composer.editorReady) {
      element.summernote('code', conversation.composer.text || '')
      return
    }
    element.summernote({
      ...intercomEditorOptions,
      placeholder: 'Type a reply to the customer...',
      callbacks: {
        onChange: function (contents) {
          conversation.composer.text = normalizeIntercomBody(contents)
          safeApply($scope)
        },
        // Pasted/dropped images: don't let Summernote insert as data: URL — convert
        // to attachments instead. Intercom's sanitizer strips data: src anyway.
        onImageUpload: function (files) {
          $scope.addReplyAttachments(conversation, files)
        }
      }
    })
    element.summernote('code', conversation.composer.text || '')
    conversation.composer.editorReady = true
  }

  function destroyIntercomReplyEditor(conversation) {
    if (!conversation || !conversation.composer || !conversation.composer.editorReady) return
    const element = $('#' + intercomReplyEditorId(conversation))
    if (element.length && $.fn.summernote) {
      element.summernote('destroy')
    }
    conversation.composer.editorReady = false
  }

  $scope.onIntercomComposerTypeChange = (conversation, nextType) => {
    if (!conversation || !conversation.composer) return
    conversation.composer.type = nextType
    if (nextType === 'note') {
      destroyIntercomReplyEditor(conversation)
    } else {
      // Re-init editor on next digest so the textarea exists in the DOM.
      setTimeout(() => initIntercomReplyEditor(conversation), 0)
    }
  }

  $scope.onIntercomConversationSelected = (conversation) => {
    setTimeout(() => initIntercomReplyEditor(conversation), 0)
  }

  $scope.toggleNewConversationComposer = () => {
    if ($scope.chatsState.newConversation.sending) return
    $scope.chatsState.newConversation.open = !$scope.chatsState.newConversation.open
    if (!$scope.chatsState.newConversation.open) {
      resetNewConversationForm()
    } else {
      // initialize on next digest so the textarea is rendered before Summernote attaches
      setTimeout(() => initIntercomNewConversationEditor(), 0)
    }
  }

  $scope.cancelNewConversation = () => {
    if ($scope.chatsState.newConversation.sending) return
    resetNewConversationForm()
  }

  $scope.canSendChatMessage = (conversation) => {
    if (!conversation || !conversation.composer) return false
    if (conversation.composer.type === 'note') {
      return !!(conversation.composer.text || '').trim()
    }
    const attachments = (conversation.composer.attachments || [])
    if (attachments.some(a => a.status === 'reading' || a.status === 'error')) return false
    const liveBody = conversation.composer.editorReady && $.fn.summernote
      ? normalizeIntercomBody($('#' + intercomReplyEditorId(conversation)).summernote('code'))
      : (conversation.composer.text || '')
    return !!liveBody.trim() || attachments.some(a => a.status === 'ready')
  }

  $scope.canSendNewConversation = () => {
    const newConversation = $scope.chatsState.newConversation || {}
    if (newConversation.sending) return false
    if (!(newConversation.subject || '').trim()) return false
    // Read live from the editor so the Send button enables as soon as the user types,
    // even before Summernote's onChange has propagated to scope.
    const liveBody = intercomNewConversationEditorReady && $.fn.summernote
      ? normalizeIntercomBody($('#intercom_new_conversation_body').summernote('code'))
      : (newConversation.body || '')
    return !!liveBody.trim()
  }

  $scope.loadChats = async (options = {}) => {
    const email = getChatRecipientEmail()
    console.log('loadChats-> client.info.email :>> ', $scope.client?.info?.email, '| resolved :>> ', email)

    if (!email) {
      toastr.error('No email on this client record.', 'Intercom Chats', { timeOut: 8000 })
      return
    }
    if ($scope.chatsState.loading) return

    $scope.chatsState.loading = true
    $scope.chatsState.error = null
    safeApply($scope)

    try {
      const result = await clientService.loadIntercomChats({
        email,
        user_id: $scope.client?.info?.id || null,   // also brings in the account's authorized users' chats
        state: $scope.chatsState.stateFilter || 'open',
        must_include_conversation_id: options?.preferredConversationId || null
      })
      if (!result?.data?.success) {
        $scope.chatsState.error = 'Unable to load chats from Intercom.'
        toastr.error($scope.chatsState.error, 'Intercom Chats', { timeOut: 10000 })
        return
      }
      const payload = result.data.data || {}
      const built = buildIntercomChatsViewModel(payload)
      $scope.chatsState.headerCSS = $sce.trustAsHtml(built.css)
      $scope.chatsState.summary = built.summary
      $scope.chatsState.conversations = built.conversations
      $scope.chatsState.sidebarOrder = built.sidebarOrder || []
      $scope.chatsState.count = built.conversations.length
      const preferredConversationId = options?.preferredConversationId != null ? String(options.preferredConversationId) : null
      const preferredSubject = stripTags(options?.preferredSubject || '').toLowerCase()
      let selectedIndex = built.sidebarOrder?.[0] ?? Math.max(0, built.conversations.length - 1)
      let matchedPreferredConversation = false

      if (preferredConversationId) {
        const preferredConversationIndex = built.conversations.findIndex(conv => String(conv.id) === preferredConversationId)
        if (preferredConversationIndex >= 0) {
          selectedIndex = preferredConversationIndex
          matchedPreferredConversation = true
        }
      }

      if (preferredSubject && !matchedPreferredConversation) {
        const orderedIndexes = built.sidebarOrder?.length
          ? built.sidebarOrder
          : built.conversations.map((conversation, index) => index)
        const preferredSubjectIndex = orderedIndexes.find(index => stripTags(built.conversations[index]?.subject || '').toLowerCase() === preferredSubject)
        if (preferredSubjectIndex >= 0) {
          selectedIndex = preferredSubjectIndex
        }
      }

      $scope.chatsState.currentIndex = selectedIndex
      $scope.chatsState.currentConv = built.conversations[selectedIndex] || null
      $scope.chatsState.loaded = true
      // Attach Summernote to the active conversation's reply textarea once the
      // sidebar/main panel render in the next digest.
      setTimeout(() => initIntercomReplyEditor($scope.chatsState.currentConv), 0)
    } catch (error) {
      console.log('loadChats-> error :>> ', error)
      $scope.chatsState.error = 'Unexpected error loading chats.'
      toastr.error($scope.chatsState.error, 'Intercom Chats', { timeOut: 10000 })
    } finally {
      $scope.chatsState.loading = false
      safeApply($scope)
      // scroll the bubbles area to its bottom after Angular renders
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const el = document.getElementById('ic-chats-bubbles')
          if (el) el.scrollTop = el.scrollHeight
        })
      })
    }
  }

  // Re-fetch a single conversation by id and splice it back into chatsState in place.
  // Used after a successful reply/note to replace the conversation cheaply, instead of
  // calling loadChats() (which re-fetches every conversation for the contact).
  // The live composer object is preserved so the user's in-progress draft (if any)
  // survives the refresh.
  async function refreshSingleConversation(conversation_id) {
    if (!conversation_id) return null
    try {
      const result = await clientService.loadIntercomConversation({ conversation_id })
      if (!result?.data?.success || !result.data.data) return null
      const rebuilt = buildConversationViewModel(result.data.data, {})
      const conversations = $scope.chatsState.conversations || []
      const index = conversations.findIndex(c => String(c.id) === String(conversation_id))
      if (index < 0) return null

      // Preserve the live composer (text, attachments, sending state, etc.) — those
      // are user-typed and must not be wiped by the refresh. We DO clear them on
      // successful send before calling this, so this preserves the post-send empty state.
      const existingComposer = conversations[index].composer
      rebuilt.composer = existingComposer || rebuilt.composer

      conversations[index] = rebuilt
      if ($scope.chatsState.currentIndex === index) {
        $scope.chatsState.currentConv = rebuilt
      }

      // Re-sort the sidebar so this conversation moves to the top (newest activity).
      $scope.chatsState.sidebarOrder = conversations
        .map((c, i) => ({ i, ts: c.updated_at || c.created_at || 0 }))
        .sort((a, b) => b.ts - a.ts)
        .map(o => o.i)

      safeApply($scope)

      // Re-attach Summernote to the (now replaced) reply textarea on next digest.
      setTimeout(() => initIntercomReplyEditor($scope.chatsState.currentConv), 0)

      // Scroll to bottom so the new bubble is in view.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const el = document.getElementById('ic-chats-bubbles')
          if (el) el.scrollTop = el.scrollHeight
        })
      })
      return rebuilt
    } catch (error) {
      console.log('refreshSingleConversation-> error :>> ', error)
      return null
    }
  }

  // -------------------------------------------------------------------------
  // Periodic refresh of the active conversation. Polls only the conversation
  // the user is currently viewing — single API call per tick — and only when:
  //   - the browser tab is visible
  //   - chatsState is loaded (panel has been opened at least once)
  //   - there is a currentConv to refresh
  //   - no send is in flight (avoid racing with the post-send reconcile)
  //
  // We don't poll in the background tab and we don't fall back to loadChats —
  // catching brand-new inbound conversations is left to the manual refresh /
  // reopening the panel. This keeps Intercom API usage bounded.
  // -------------------------------------------------------------------------
  const INTERCOM_POLL_INTERVAL_MS = 30 * 1000
  let intercomPollHandle = null
  let intercomPollInFlight = false

  // The ring is a CSS keyframe animation — we don't drive its value from JS.
  // Bumping intercomPollAnimKey forces Angular to re-render the ring element via
  // a single-item ng-repeat keyed by this value, which restarts the animation
  // cleanly on every refresh (auto, manual, or visibility-triggered).
  $scope.intercomPollAnimKey = 0
  $scope.intercomPollDurationMs = INTERCOM_POLL_INTERVAL_MS
  $scope.intercomPollRefreshing = false

  function isChatsTabActive() {
    if (typeof document === 'undefined') return false
    const pane = document.getElementById('client-chats-tab')
    return !!(pane && pane.classList && pane.classList.contains('active'))
  }

  function shouldPollIntercomNow() {
    if (typeof document !== 'undefined' && document.visibilityState && document.visibilityState !== 'visible') return false
    if (!isChatsTabActive()) return false
    const cs = $scope.chatsState
    if (!cs || !cs.loaded || cs.loading) return false
    const current = cs.currentConv
    if (!current || !current.id) return false
    if (current.composer && current.composer.sending) return false
    return true
  }

  function restartIntercomRingAnimation() {
    // Bumping the key triggers Angular to destroy + recreate the ring DOM node,
    // which restarts the CSS keyframe animation from 0%.
    $scope.intercomPollAnimKey = ($scope.intercomPollAnimKey + 1) % 1000000
  }

  async function pollActiveConversation({ manual = false } = {}) {
    if (intercomPollInFlight) return
    if (!manual && !shouldPollIntercomNow()) {
      // Even if we skip, restart the ring so it doesn't sit at 100% staring at the user.
      restartIntercomRingAnimation()
      return
    }
    const target = $scope.chatsState.currentConv
    const targetId = target && target.id
    if (!targetId) {
      restartIntercomRingAnimation()
      return
    }
    intercomPollInFlight = true
    $scope.intercomPollRefreshing = true
    safeApply($scope)
    try {
      await refreshSingleConversation(targetId)
    } catch (error) {
      console.log('pollActiveConversation-> error :>> ', error)
    } finally {
      intercomPollInFlight = false
      $scope.intercomPollRefreshing = false
      restartIntercomRingAnimation()
      safeApply($scope)
    }
  }

  function startIntercomPolling() {
    if (intercomPollHandle) return
    intercomPollHandle = setInterval(pollActiveConversation, INTERCOM_POLL_INTERVAL_MS)
    restartIntercomRingAnimation()
  }

  function stopIntercomPolling() {
    if (intercomPollHandle) {
      clearInterval(intercomPollHandle)
      intercomPollHandle = null
    }
  }

  // Manual refresh button: refresh now, reset countdown to 30s, restart cycle.
  $scope.manualRefreshChat = async () => {
    if (intercomPollInFlight) return
    // Cancel and recreate the interval so the next auto-tick is exactly 30s
    // from this manual click, not whenever the original tick was scheduled.
    stopIntercomPolling()
    await pollActiveConversation({ manual: true })
    startIntercomPolling()
  }

  // Resume promptly when the tab becomes visible again rather than waiting up
  // to 30s for the next interval tick.
  function onIntercomVisibilityChange() {
    if (document.visibilityState === 'visible') {
      pollActiveConversation()
    }
  }
  if (typeof document !== 'undefined' && document.addEventListener) {
    document.addEventListener('visibilitychange', onIntercomVisibilityChange)
  }
  startIntercomPolling()
  $scope.$on('$destroy', () => {
    stopIntercomPolling()
    if (typeof document !== 'undefined' && document.removeEventListener) {
      document.removeEventListener('visibilitychange', onIntercomVisibilityChange)
    }
  })

  // Build an optimistic bubble for the just-sent reply/note and append it to the
  // current conversation's bubbles_html. Returns a sentinel id so the caller can
  // identify and remove the bubble if the API call fails.
  function appendOptimisticBubble(conversation, { messageType, body, attachments }) {
    if (!conversation) return null
    const optimisticId = `optimistic_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`
    const now = Math.floor(Date.now() / 1000)
    const adminName = $scope.user?.name || $scope.user?.first_name || 'Teammate'
    const adminEmail = $scope.user?.email || ''

    const item = {
      author: { type: 'admin', name: adminName, email: adminEmail },
      body: body || '',
      created_at: now,
      part_type: messageType === 'note' ? 'note' : 'comment',
      attachments: (attachments || []).map(a => ({
        name: a.name,
        content_type: a.content_type,
        url: '',
        filesize: a.size,
        inline: false
      })),
      seen: false,
      _optimistic: optimisticId
    }

    const fmt = ts => ts ? new Date(ts * 1000).toLocaleString() : '-'
    const ctx = {
      contactName: conversation.from_name || 'Customer',
      statistics: {},
      channel: (conversation.channel || '').toLowerCase()
    }
    const newBubbleHtml = renderBubble(item, fmt, ctx)
    // bubbles_html is wrapped in $sce.trustAsHtml — pull the raw string back out.
    const existingHtml = $sce.getTrustedHtml(conversation.bubbles_html) || ''
    const wrappedNew = `<div data-optimistic-id="${optimisticId}">${newBubbleHtml}</div>`
    conversation.bubbles_html = $sce.trustAsHtml(existingHtml + wrappedNew)

    safeApply($scope)
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const el = document.getElementById('ic-chats-bubbles')
        if (el) el.scrollTop = el.scrollHeight
      })
    })
    return optimisticId
  }

  function removeOptimisticBubble(conversation, optimisticId) {
    if (!conversation || !optimisticId) return
    const existingHtml = $sce.getTrustedHtml(conversation.bubbles_html) || ''
    // Strip the wrapper div with the matching data-optimistic-id and its contents.
    const escaped = optimisticId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const re = new RegExp(`<div data-optimistic-id="${escaped}">[\\s\\S]*?<\\/div>\\s*$`)
    const stripped = existingHtml.replace(re, '')
    conversation.bubbles_html = $sce.trustAsHtml(stripped)
    safeApply($scope)
  }

  $scope.sendChatMessage = async (conversation) => {
    if (!conversation || conversation.composer.sending) return
    const body = syncIntercomReplyFromEditor(conversation).trim()
    const messageType = conversation.composer.type === 'note' ? 'note' : 'comment'
    const attachments = ensureAttachmentsArray(conversation) || []

    if (messageType === 'note' && attachments.length > 0) {
      toastr.warning('Internal notes cannot have attachments. Remove them or switch to Reply.', 'Intercom Chats', { timeOut: 8000 })
      return
    }
    if (attachments.some(a => a.status === 'reading')) {
      toastr.warning('Wait for attachments to finish loading.', 'Intercom Chats', { timeOut: 5000 })
      return
    }
    const failedAttachments = attachments.filter(a => a.status === 'error')
    if (failedAttachments.length) {
      toastr.warning('Remove failed attachments before sending.', 'Intercom Chats', { timeOut: 6000 })
      return
    }
    if (!body && attachments.length === 0) {
      toastr.warning('Please enter a message or add an attachment before sending.', 'Intercom Chats', { timeOut: 5000 })
      return
    }

    const adminId = $scope.user?.intercom_agent_id
    if (!adminId) {
      toastr.error('Your user record has no intercom_agent_id configured.', 'Intercom Chats', { timeOut: 10000 })
      return
    }

    const attachmentPayload = attachments
      .filter(a => a.status === 'ready' && a.file_data)
      .map(a => ({ name: a.name, content_type: a.content_type, file_data: a.file_data }))

    // Snapshot what we're sending for the optimistic bubble (so the user sees
    // their message immediately, without waiting for a network round-trip).
    const optimisticAttachments = attachments
      .filter(a => a.status === 'ready')
      .map(a => ({ name: a.name, content_type: a.content_type, size: a.size }))

    conversation.composer.sending = true
    safeApply($scope)

    // Append optimistic bubble immediately. Captured id lets us undo on failure.
    const optimisticId = appendOptimisticBubble(conversation, {
      messageType,
      body,
      attachments: optimisticAttachments
    })

    try {
      const result = await clientService.sendIntercomReply({
        conversation_id: conversation.id,
        message_type: messageType,
        body: body,
        admin_id: adminId,
        attachment_files: attachmentPayload.length ? attachmentPayload : undefined
      })
      if (!result?.data?.success) {
        removeOptimisticBubble(conversation, optimisticId)
        toastr.error(result?.data?.error?.message || 'Unable to send message to Intercom.', 'Intercom Chats', { timeOut: 10000 })
        return
      }
      toastr.success(`${messageType === 'note' ? 'Note' : 'Reply'} sent.`, 'Intercom Chats', { timeOut: 4000 })
      conversation.composer.text = ''
      conversation.composer.attachments = []
      if (conversation.composer.editorReady && $.fn.summernote) {
        const element = $('#' + intercomReplyEditorId(conversation))
        if (element.length) element.summernote('code', '')
      }
      // Reconcile: re-fetch just this conversation and splice it back in. The
      // rebuilt conversation replaces the entire bubbles_html, which naturally
      // drops the optimistic bubble in favor of the real one from Intercom.
      // We don't await this — the optimistic bubble already covers the user's UX.
      refreshSingleConversation(conversation.id)
    } catch (error) {
      console.log('sendChatMessage-> error :>> ', error)
      removeOptimisticBubble(conversation, optimisticId)
      toastr.error('Unexpected error sending message.', 'Intercom Chats', { timeOut: 10000 })
    } finally {
      conversation.composer.sending = false
      safeApply($scope)
    }
  }

  $scope.createNewConversation = async () => {
    const newConversation = $scope.chatsState.newConversation
    if (!newConversation || newConversation.sending) return

    const email = getChatRecipientEmail()
    if (!email) {
      toastr.error('No email on this client record.', 'Intercom Chats', { timeOut: 8000 })
      return
    }

    const adminId = $scope.user?.intercom_agent_id
    if (!adminId) {
      toastr.error('Your user record has no intercom_agent_id configured.', 'Intercom Chats', { timeOut: 10000 })
      return
    }

    const subject = (newConversation.subject || '').trim()
    // Pull formatting-rich HTML directly from Summernote — onChange isn't reliable
    // for every toolbar action (color, font size).
    const body = syncIntercomNewConversationFromEditor()

    if (!subject || !body) {
      toastr.warning('Subject and message body are required.', 'Intercom Chats', { timeOut: 5000 })
      return
    }

    newConversation.sending = true
    safeApply($scope)

    try {
      const result = await clientService.createIntercomConversation({
        admin_id: adminId,
        email: email,
        name: getChatRecipientName(),
        external_id: $scope.client?.info?.id,
        subject: subject,
        body: body
      })

      if (!result?.data?.success) {
        toastr.error(result?.data?.error?.message || 'Unable to create conversation in Intercom.', 'Intercom Chats', { timeOut: 10000 })
        return
      }

      resetNewConversationForm()
      $scope.chatsState.stateFilter = 'open'
      toastr.success('Conversation created.', 'Intercom Chats', { timeOut: 4000 })
      await $scope.loadChats({
        preferredConversationId: result?.data?.data?.conversation_id,
        preferredSubject: result?.data?.data?.subject || subject
      })
    } catch (error) {
      console.log('createNewConversation-> error :>> ', error)
      toastr.error('Unexpected error creating conversation.', 'Intercom Chats', { timeOut: 10000 })
    } finally {
      $scope.chatsState.newConversation.sending = false
      safeApply($scope)
    }
  }

  function buildIntercomChatsViewModel(payload) {
    const conversations = payload?.conversations || []
    const fmt = ts => ts ? new Date(ts * 1000).toLocaleString() : '-'

    const css = `
      <style>
        .ic-chats .ic-bubble-body { font-size: 13px; line-height: 1.4; }
        .ic-chats .ic-bubble-body ul,
        .ic-chats .ic-bubble-body ol { padding-left: 22px; margin: 6px 0; list-style-position: outside; }
        .ic-chats .ic-bubble-body ul { list-style-type: disc; }
        .ic-chats .ic-bubble-body ol { list-style-type: decimal; }
        .ic-chats .ic-bubble-body li { margin-bottom: 4px; line-height: 1.4; padding-left: 8px; }
        .ic-chats .ic-bubble-body li::marker { color: #6c757d; }
        .ic-chats .ic-bubble-body p { margin: 0 0 6px 0; }
        .ic-chats .ic-bubble-body p:last-child { margin-bottom: 0; }
        .ic-chats .ic-bubble-body a { color: inherit; text-decoration: underline; }
        .ic-chats .ic-bubble-body blockquote {
          border-left: 3px solid rgba(0,0,0,0.15);
          margin: 6px 0;
          padding: 2px 10px;
          color: inherit;
          opacity: 0.85;
        }
        .ic-chats .ic-bubble-body img { max-width: 100%; height: auto; border-radius: 4px; }
        .ic-chats .ic-bubble-body pre,
        .ic-chats .ic-bubble-body code {
          background: rgba(0,0,0,0.05);
          border-radius: 4px;
          padding: 1px 4px;
          font-size: 12px;
        }
        .ic-chats .ic-bubble-body pre { padding: 8px 10px; overflow-x: auto; }
        /* Reply/Note dropdown — keep dark on hover & focus (Bootstrap default is white-on-white). */
        .ic-chats .dropdown-menu .dropdown-item {
          color: #F5F5F5;
          background-color: transparent;
        }
        .ic-chats .dropdown-menu .dropdown-item:hover,
        .ic-chats .dropdown-menu .dropdown-item:focus,
        .ic-chats .dropdown-menu .dropdown-item.active {
          color: #FFFFFF;
          background-color: #3a3f47;
        }
        /* Refresh Chat button — labeled pill with a circular countdown ring on the right. */
        .ic-refresh-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 4px 4px 4px 10px;
          border-radius: 16px;
          border: 1px solid #3a3f47;
          background: #2B2F35;
          color: #F5F5F5;
          cursor: pointer;
          flex: 0 0 auto;
          font-size: 13px;
          line-height: 1;
        }
        .ic-refresh-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        .ic-refresh-btn .ic-refresh-circle {
          position: relative;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          flex: 0 0 auto;
        }
        /* Filled portion grows from 0% (empty) to 100% (full) over the poll interval.
           The CSS variable --p is what the conic gradient reads. We animate it via
           @property so the conic-gradient transitions smoothly (Chromium-based + Safari).
           Firefox falls back to no animation but still shows the icon. */
        @property --p {
          syntax: '<integer>';
          initial-value: 0;
          inherits: true;
        }
        .ic-refresh-btn .ic-refresh-fill {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          background: conic-gradient(#7aa7ff calc(var(--p, 0) * 1%), rgba(122,167,255,0.15) 0);
          mask: radial-gradient(circle, transparent 7px, #000 8px);
          -webkit-mask: radial-gradient(circle, transparent 7px, #000 8px);
          --p: 0;
          animation: ic-refresh-fill var(--ic-refresh-duration, 30s) linear forwards;
        }
        @keyframes ic-refresh-fill {
          from { --p: 0; }
          to   { --p: 100; }
        }
        .ic-refresh-btn .ic-refresh-icon {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 11px;
          color: #F5F5F5;
        }
      </style>
    `

    const summary = {
      empty: conversations.length === 0,
      email: payload?.email || '',
      conversation_count: conversations.length,
      contact_count: (payload?.contacts || []).length
    }

    const built = conversations.map(conv => buildConversationViewModel(conv, { fmt }))

    // Sidebar order: newest activity first (by updated_at, fall back to created_at)
    const sidebarOrder = built
      .map((c, i) => ({ i, ts: c.updated_at || c.created_at || 0 }))
      .sort((a, b) => b.ts - a.ts)
      .map(o => o.i)

    return { css, summary, conversations: built, sidebarOrder }
  }

  // Build the view model for a single conversation. Reused by both the full chat-list
  // builder and the post-send single-conversation refresh path. The `fmt` helper is
  // identical to the one in buildIntercomChatsViewModel; default it locally so this
  // function can also be called standalone.
  function buildConversationViewModel(conv, ctx) {
    const fmt = (ctx && ctx.fmt) || (ts => ts ? new Date(ts * 1000).toLocaleString() : '-')
    const rawSubject = conv?.source?.subject || ''
    const subject = stripTags(rawSubject) || '(no subject)'
    const fromAuthor = conv?.source?.author || {}

    const stream = []
    if (conv?.source?.body) {
      stream.push({
        author: fromAuthor,
        body: conv.source.body,
        created_at: conv.created_at,
        part_type: 'comment',
        attachments: conv?.source?.attachments || []
      })
    }
    const parts = (conv?.conversation_parts?.conversation_parts || []).filter(p => p)
    parts.forEach(p => stream.push({
      author: p.author || {},
      body: p.body || '',
      created_at: p.created_at,
      part_type: p.part_type || '',
      notified_at: p.notified_at,
      external_id: p.external_id,
      read: !!p.read,
      attachments: p.attachments || []
    }))

    // Determine "seen" status per admin reply. We try the strongest signals first.
    const convRead = conv?.read === true
    const convClosed = (conv?.state || '').toLowerCase() === 'closed' || conv?.open === false
    const lastContactReplyAt = conv?.statistics?.last_contact_reply_at || 0

    let lastUserPartAt = 0
    stream.forEach(s => {
      const isUser = !(s.author?.type === 'admin' || s.author?.type === 'bot')
      if (isUser && s.created_at && s.created_at > lastUserPartAt) lastUserPartAt = s.created_at
    })

    const seenEligibleTypes = new Set(['comment', 'assignment', ''])
    stream.forEach(s => {
      const isAdmin = s.author?.type === 'admin'
      const eligible = seenEligibleTypes.has(s.part_type) && s.body
      if (!(isAdmin && eligible)) {
        s.seen = false
        return
      }
      if (s.read) { s.seen = true; return }
      if (convRead) { s.seen = true; return }
      if (lastContactReplyAt > 0 && s.created_at && lastContactReplyAt > s.created_at) { s.seen = true; return }
      if (lastUserPartAt > 0 && s.created_at && lastUserPartAt > s.created_at) { s.seen = true; return }
      if (convClosed) { s.seen = true; return }
      s.seen = false
    })

    const renderCtx = {
      contactName: fromAuthor.name || fromAuthor.email || 'Customer',
      statistics: conv?.statistics || {},
      channel: (conv?.source?.type || '').toLowerCase()
    }
    let bubblesHtml = ''
    stream.forEach(item => { bubblesHtml += renderBubble(item, fmt, renderCtx) })

    const latestWithBody = [...stream].reverse().find(s => s.body) || { author: fromAuthor, body: conv?.source?.body || '', created_at: conv.created_at, part_type: 'comment' }
    const latestAuthor = latestWithBody.author || {}
    const latestType = latestWithBody.part_type || ''
    const previewText = stripTags(latestWithBody.body || '').slice(0, 140)

    const fromName = fromAuthor.name || fromAuthor.email || 'Unknown'
    const initial = (fromName.trim()[0] || '?').toUpperCase()

    return {
      id: conv.id,
      subject,
      intercom_url: `https://app.intercom.com/a/inbox/_/inbox/conversation/${conv.id}`,
      created: fmt(conv.created_at),
      created_at: conv.created_at,
      updated: fmt(conv.updated_at),
      updated_at: conv.updated_at,
      channel: conv?.source?.type || '',
      state: conv.state || '',
      open_text: conv.open ? '(open)' : '(closed)',
      from_name: fromName,
      from_initial: initial,
      preview: previewText,
      latest_relative: relativeTime(latestWithBody.created_at),
      latest_is_note: latestType === 'note',
      latest_is_admin: (latestAuthor.type === 'admin' || latestAuthor.type === 'bot'),
      bubbles_html: $sce.trustAsHtml(bubblesHtml || '<div style="font-size:12px;color:#a0a6ae">No messages.</div>'),
      composer: { type: 'reply', text: '', sending: false }
    }
  }

  function formatFullTimestamp(ts) {
    if (!ts) return ''
    const d = new Date(ts * 1000)
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    const yyyy = d.getFullYear()
    let hours = d.getHours()
    const minutes = String(d.getMinutes()).padStart(2, '0')
    const ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12 || 12
    return `${mm}/${dd}/${yyyy}  ${hours}:${minutes}${ampm}`
  }

  function relativeTime(ts) {
    if (!ts) return ''
    const seconds = Math.floor((Date.now() / 1000) - ts)
    if (seconds < 60) return `${seconds}s`
    const minutes = Math.floor(seconds / 60)
    if (minutes < 60) return `${minutes}m`
    const hours = Math.floor(minutes / 60)
    if (hours < 24) return `${hours}h`
    const days = Math.floor(hours / 24)
    if (days < 30) return `${days}d`
    const months = Math.floor(days / 30)
    if (months < 12) return `${months}mo`
    const years = Math.floor(days / 365)
    return `${years}y`
  }

  function renderBubble(item, fmt, ctx) {
    ctx = ctx || {}
    const author = item.author || {}
    const isAdmin = author.type === 'admin' || author.type === 'bot'
    const isNote = item.part_type === 'note'
    const attachments = (item.attachments || []).filter(a => a && a.url)
    // Skip system/event parts that have no body and no attachments
    if (!item.body && attachments.length === 0) {
      if (item.part_type && item.part_type !== 'comment' && item.part_type !== 'note') {
        return `<div style="text-align:center;font-size:11px;color:#6c757d;margin:6px 0">
          ${escapeHtml(item.part_type.replace(/_/g, ' '))} &middot; ${fmt(item.created_at)}
        </div>`
      }
      return ''
    }

    let bg, color, align, border, dividerColor, mutedColor, linkColor
    if (isNote) {
      bg = '#45380c'
      color = '#FAFAE0'
      border = '1px solid #2e2608'
      dividerColor = 'rgba(250,250,224,0.18)'
      mutedColor = 'rgba(250,250,224,0.65)'
      linkColor = '#ffd479'
      align = 'flex-end'
    } else if (isAdmin) {
      bg = '#253956'
      color = '#FAFAEF'
      border = '1px solid #15233a'
      dividerColor = 'rgba(250,250,239,0.18)'
      mutedColor = 'rgba(250,250,239,0.65)'
      linkColor = '#7aa7ff'
      align = 'flex-end'
    } else {
      bg = '#2B2F35'
      color = '#F5F5F5'
      border = '1px solid #1a1d22'
      dividerColor = 'rgba(245,245,245,0.18)'
      mutedColor = 'rgba(245,245,245,0.6)'
      linkColor = '#7aa7ff'
      align = 'flex-start'
    }

    const authorName = author.name || author.email || (isAdmin ? 'Teammate' : 'Client')
    const authorEmail = author.email || ''
    const recipientName = isAdmin ? (ctx.contactName || 'Customer') : 'PropertyTax.io Support Team'

    const noteTag = isNote
      ? `<span style="background:#f1e394;color:#5a4a00;border-radius:3px;padding:1px 6px;font-size:10px;margin-left:6px;font-weight:600;letter-spacing:0.5px">NOTE</span>`
      : ''

    const body = sanitizeHtml(item.body || '')

    // Footer: relative time, plus a "Seen" indicator only when we can prove the customer engaged
    // after this admin reply. The Intercom REST API doesn't expose a true per-part read receipt,
    // so we don't show "Not Seen" — that would be a guess. Just show the timestamp in that case.
    const relTime = relativeTime(item.created_at)
    const fullTimeTitle = formatFullTimestamp(item.created_at)
    const relTimeHtml = `<span title="${escapeHtml(fullTimeTitle)}" style="cursor:help">${escapeHtml(relTime)}</span>`
    const isBot = author.type === 'bot'
    const showSeenStatus = isAdmin && !isNote && !isBot && item.seen
    let seenLabel
    if (showSeenStatus) {
      seenLabel = `<span style="color:${mutedColor};margin-right:4px">Seen</span>&middot;<span style="margin-left:4px">${relTimeHtml}</span>`
    } else {
      seenLabel = relTimeHtml
    }

    // Channel icon: envelope for email, comment-bubble for chat/messenger.
    // Intercom source.type values: "email", "conversation" (messenger/chat), "chat", "push", etc.
    // Only "email" should render the envelope.
    // Suppress entirely for Operator/bot messages — those aren't sent over a channel the user can read.
    const channel = (ctx.channel || '').toLowerCase()
    const isEmailChannel = channel === 'email'
    const channelIconClass = isEmailChannel ? 'fal fa-envelope' : 'fal fa-comment-alt-lines'
    const channelIconTitle = isEmailChannel ? 'Email' : 'Chat'
    const statusIcons = isBot
      ? `<div></div>`
      : `
        <div style="display:flex;align-items:center;gap:6px;color:${mutedColor};font-size:12px" title="${channelIconTitle}">
          <i class="${channelIconClass}" style="font-size:14px"></i>
        </div>
      `

    // Inject "to: ..." line and proper From label only for emails. For chat-style messages we keep it lean.
    const isEmail = (item.part_type === 'comment' || item.part_type === 'note') && (author.type !== 'user' || (item.body || '').length > 80)
    const headerBlock = `
      <div style="padding:10px 14px 8px 14px">
        <div style="font-weight:700;font-size:13px;color:${color}">
          ${escapeHtml(authorName)}${noteTag}
        </div>
        ${authorEmail ? `<div style="font-size:12px;color:${mutedColor};margin-top:1px">&lt;${escapeHtml(authorEmail)}&gt;</div>` : ''}
        ${isEmail ? `<div style="font-size:12px;color:${mutedColor};margin-top:2px">to: ${escapeHtml(recipientName)}</div>` : ''}
      </div>
      <div style="border-top:1px solid ${dividerColor};margin:0 14px"></div>
    `

    // Attachment pills — exclude inline images (those render in the body via <img>) and zero-byte items.
    // For images: route the click through the existing data-ic-view-attachment interceptor so they
    // open in a new tab instead of replacing the current tab. The browser's download="" attribute
    // is only respected for same-origin or CORS-permitted resources, so images served by Intercom
    // typically navigate inline — the click interceptor sidesteps that.
    const attachmentPills = attachments
      .filter(a => !((a.content_type || '').startsWith('image/') && a.inline === true))
      .map(a => {
        const name = a.name || a.url.split('/').pop() || 'attachment'
        const sizeLabel = formatAttachmentSize(a.filesize)
        const safeUrl = escapeHtml(a.url)
        const safeName = escapeHtml(name)
        const safeContentType = escapeHtml(a.content_type || '')
        const isImage = (a.content_type || '').startsWith('image/')
        const linkAttrs = isImage
          ? `href="${safeUrl}" target="_blank" rel="noopener" data-ic-view-attachment="${safeUrl}" data-ic-content-type="${safeContentType}" title="Open ${safeName} in new tab"`
          : `href="${safeUrl}" download="${safeName}" rel="noopener" title="Download ${safeName}"`
        return `
          <a ${linkAttrs}
             style="display:inline-flex;align-items:center;gap:8px;padding:8px 12px;background:rgba(255,255,255,0.06);border:1px solid ${dividerColor};border-radius:8px;text-decoration:none;color:${color};font-size:13px;max-width:100%">
            <i class="fal ${isImage ? 'fa-image' : 'fa-paperclip'}" style="color:${mutedColor};font-size:13px;flex:0 0 auto"></i>
            <span style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex:1 1 auto;min-width:0">${safeName}</span>
            ${sizeLabel ? `<span style="color:${mutedColor};font-size:12px;flex:0 0 auto">${escapeHtml(sizeLabel)}</span>` : ''}
          </a>
        `
      })
      .join('')

    const attachmentsBlock = attachmentPills
      ? `<div style="display:flex;flex-wrap:wrap;gap:8px;padding:0 14px 10px 14px">${attachmentPills}</div>`
      : ''

    const bodyBlock = item.body
      ? `
        <div class="ic-bubble-body" style="font-size:13px;line-height:1.5;padding:10px 14px;color:${color}">
          ${body}
        </div>
      `
      : ''

    const footerBlock = `
      <div style="display:flex;justify-content:space-between;align-items:center;padding:6px 14px 10px 14px">
        ${statusIcons}
        <div style="font-size:12px;color:${mutedColor}">
          ${seenLabel}
        </div>
      </div>
    `

    return `
      <div style="display:flex;justify-content:${align};margin-bottom:14px">
        <div style="max-width:78%;background:${bg};color:${color};border:${border};border-radius:10px;box-shadow:0 1px 2px rgba(0,0,0,0.18);overflow:hidden;--ic-link-color:${linkColor}">
          ${headerBlock}
          ${bodyBlock}
          ${attachmentsBlock}
          ${footerBlock}
        </div>
      </div>`
  }

  function formatAttachmentSize(bytes) {
    const n = Number(bytes || 0)
    if (!n || n <= 0) return ''
    if (n < 1024) return `${n} B`
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`
    if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(2)} MB`
    return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }

  function sanitizeHtml(html) {
    // strip <script> tags and inline event handlers; keep basic markup Intercom returns
    // also force list spacing inline so it isn't overridden by global stylesheets
    const ulStyle = 'padding-left:36px !important;margin:6px 0 6px 4px !important;list-style-position:outside !important;list-style-type:disc !important;'
    const olStyle = 'padding-left:36px !important;margin:6px 0 6px 4px !important;list-style-position:outside !important;list-style-type:decimal !important;'
    const liStyle = 'margin-bottom:4px !important;line-height:1.4 !important;padding-left:8px !important;display:list-item !important;margin-left:30px !important;'
    const imgStyle = 'cursor:zoom-in;max-width:100%;height:auto;border-radius:4px;'
    return String(html || '')
      .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
      .replace(/ on\w+="[^"]*"/gi, '')
      .replace(/ on\w+='[^']*'/gi, '')
      .replace(/<ul\b([^>]*)>/gi, (_m, attrs) => `<ul${mergeStyle(attrs, ulStyle)}>`)
      .replace(/<ol\b([^>]*)>/gi, (_m, attrs) => `<ol${mergeStyle(attrs, olStyle)}>`)
      .replace(/<li\b([^>]*)>/gi, (_m, attrs) => `<li${mergeStyle(attrs, liStyle)}>`)
      .replace(/<img\b([^>]*)>/gi, (_m, attrs) => `<img${mergeStyle(attrs, imgStyle)} data-ic-lightbox="1">`)
  }

  function mergeStyle(existingAttrs, addStyle) {
    const styleMatch = /style\s*=\s*"([^"]*)"/i.exec(existingAttrs || '')
    if (styleMatch) {
      const merged = `${styleMatch[1].replace(/;?\s*$/, '')};${addStyle}`
      return existingAttrs.replace(/style\s*=\s*"[^"]*"/i, `style="${merged}"`)
    }
    return `${existingAttrs || ''} style="${addStyle}"`
  }

  function stripTags(html) {
    return String(html || '')
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
  }

  $scope.submit = function (action) {
    switch (action) {
      case 'add_client':
        createClient()
        break
    }
  }

  const createClient = async () => {
    let obj = { ...$scope.client, promocode: "" }
    let createClientAccountResult = await clientService.createClientAccount(obj)

    if (createClientAccountResult.data.success) {
      $scope.client.record.id = createClientAccountResult.data.data.user_id
      $scope.client.record.token = createClientAccountResult.data.data.token
    } else {
      toastr.error("There was an error creating the account", "Creating an Account Error!", { timeOut: 15000 })
      return
    }
    clientService.setClientObj($scope.client)
    console.log('$scope.client :>> ', $scope.client);
    $scope.navChange('clients_edit')
    safeApply($scope)
    toastr.success("Client Account Created", "Success!", { timeOut: 5000 })
  }

  $scope.route = (route, options) => {
    let flags = '_self'
    if (options.hasOwnProperty('open_new_tab') && options.open_new_tab == true) {
      flags = '_blank'
    }
    $window.open(route, flags)
  }

  $scope.clientActionButtons = async (action, user_id = 0) => {
    let url = ''
    switch (action) {
      case 'refresh':
        $scope.editmode_clientinfo = false
        loadClientDetails()
        break
      case 'merge_properties':
        $scope.mergePropertiesFromAnotherAccount('showMergeModal', user_id)
        break
      case 'view_dashboard':
        url = $scope.getDashboardLink()
        $scope.route(url, { open_new_tab: true })
        break
      case 'convert_to_partner':
        if (user_id != 0) convertToPartner(user_id)
        break
      case 'copy_dashboard_link':
        toastr.success("Dashboard Link Copied to Clipboard", "Success!", { timeOut: 5000 })
        break
      case 'activate_account':
        const activateAccountObj = { user_id: $scope.client.info.id }
        const activateAccountResults = await clientService.activateAccount(activateAccountObj)
        console.log('activateAccountResults.data.success :>> ', activateAccountResults.data.success);
        if (activateAccountResults.data.success) {
          $scope.client.info.account_verified = 1
          toastr.success("Account Activated", "Success!", { timeOut: 5000 })
        } else {
          toastr.error("Error Activating Account", "Failed!", { timeOut: 10000 })
        }
        safeApply($scope)
        break
    }
  }
  $scope.getDashboardLink = () => {
    try {
      if (!$scope.client?.info) return ''
      if ($scope.client.info.id && $scope.client.info.token) {
        if ($scope.client.info.business_source == 'TPTC') {
          return `https://dashboard.texasptc.com/${$scope.client.info.id}/${$scope.client.info.token}`
        } else {
          return `https://dashboard.propertytax.io/${$scope.client.info.id}/${$scope.client.info.token}`
        }
      } else {
        return ''
      }
    } catch (error) {
      // console.log('error :>> ', error);
      return ''
    }
  }

  function getEvidencePortalUrl(prop_id) {
    if (!$scope.client?.info?.id || !$scope.client?.info?.token || !prop_id) return ''
    return `https://evidence.propertytax.io/${$scope.client.info.id}/${$scope.client.info.token}/${prop_id}`
  }

  $scope.openEvidencePortal = (prop_id) => {
    const url = getEvidencePortalUrl(prop_id)
    if (!url) {
      toastr.error('URL NOT Found')
      return
    }
    $window.open(url, '_blank')
  }

  // Clipboard write with a fallback for non-secure contexts, where
  // navigator.clipboard is unavailable.
  const copyTextToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
      return
    }
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-9999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    document.execCommand('copy')
    document.body.removeChild(textArea)
  }

  // portal_url: the property's evidence_portal_url (brand-aware) when the caller has it
  $scope.copyEvidencePortalLink = async (prop_id, portal_url) => {
    const url = portal_url || getEvidencePortalUrl(prop_id)
    if (!url) {
      toastr.error('URL NOT Found')
      return
    }

    try {
      await copyTextToClipboard(url)
      toastr.success('Portal Link Copied!', 'Success!', { timeOut: 4000 })
    } catch (error) {
      toastr.error('Could not copy Portal Link', 'Failed!', { timeOut: 8000 })
    }
  }

  // Client dashboard link that opens with this property selected (dashboard's /@{prop_id} deep-link)
  $scope.copyDashboardPropertyLink = async (prop_id) => {
    const dashboardUrl = $scope.getDashboardLink()
    if (!dashboardUrl || !prop_id) {
      toastr.error('URL NOT Found')
      return
    }

    try {
      await copyTextToClipboard(`${dashboardUrl}/@${prop_id}`)
      toastr.success('Dashboard Property Link Copied!', 'Success!', { timeOut: 4000 })
    } catch (error) {
      toastr.error('Could not copy Dashboard Property Link', 'Failed!', { timeOut: 8000 })
    }
  }

  // Dashboard's per-appeal Tax Savings Details page:
  // /invoice_details/details/{appeal_id}/{user_id}/{token} - the id is the APPEAL id, not the prop id
  $scope.copyTaxSavingsDetailsLink = async (appeal_id) => {
    const info = $scope.client?.info
    if (!info?.id || !info?.token || !appeal_id) {
      toastr.error('URL NOT Found')
      return
    }
    try {
      await copyTextToClipboard(`${dashboardHost(info)}/invoice_details/details/${appeal_id}/${info.id}/${info.token}`)
      toastr.success('Tax Savings Details Link Copied!', 'Success!', { timeOut: 4000 })
    } catch (error) {
      toastr.error('Could not copy Tax Savings Details Link', 'Failed!', { timeOut: 8000 })
    }
  }

  // Dashboard invoice page: /invoice_details/invoice/{tax_year}/{user_id}/{token}
  $scope.copyInvoiceLink = async (tax_year) => {
    const info = $scope.client?.info
    if (!info?.id || !info?.token || !tax_year) {
      toastr.error('URL NOT Found')
      return
    }

    try {
      await copyTextToClipboard(`${dashboardHost(info)}/invoice_details/invoice/${tax_year}/${info.id}/${info.token}`)
      toastr.success('Invoice Link Copied!', 'Success!', { timeOut: 4000 })
    } catch (error) {
      toastr.error('Could not copy Invoice Link', 'Failed!', { timeOut: 8000 })
    }
  }

  // Tax year for the client-level invoice link: the latest year among current appeals
  // that have an official invoice date, or null when nothing has been invoiced yet
  $scope.clientInvoiceYear = () => {
    const years = ($scope.client?.properties || [])
      .map(p => p?.appeal_current)
      .filter(a => a && a.official_invoice_date && a.tax_year)
      .map(a => Number(a.tax_year))
    return years.length ? Math.max(...years) : null
  }

  function dashboardHost(info) {
    return info.business_source == 'TPTC' ? 'https://dashboard.texasptc.com' : 'https://dashboard.propertytax.io'
  }

  // Only render the Evidence Submitted to CAD link when the stored value is
  // actually a URL - the column can also hold free text or be empty.
  $scope.isEvidenceReportUrl = (value) => {
    if (!value || typeof value !== 'string') return false
    return /^https?:\/\/\S+$/i.test(value.trim())
  }

  $scope.copyEvidenceReportLink = async (url) => {
    if (!$scope.isEvidenceReportUrl(url)) {
      toastr.error('URL NOT Found')
      return
    }

    try {
      await copyTextToClipboard(url.trim())
      toastr.success('Evidence Report Link Copied!', 'Success!', { timeOut: 4000 })
    } catch (error) {
      toastr.error('Could not copy Evidence Report Link', 'Failed!', { timeOut: 8000 })
    }
  }

  //#region -- Merge Properties functions
  // ----------------------------------------------------------------------------------------------------  
  $scope.mergePropertiesFromAnotherAccount = async (action, user_id, token) => {
    console.log('action :>> ', action);
    let mergePropertiesFromAnotherAccountModal
    switch (action) {
      case 'showMergeModal':
        $scope.mergePropertiesModalScope = {
          properties: [],
          user_name: "",
          user_email: "",
          user_id: 0,
          authorized_users: 0,
          allChecked: false
        }
        mergePropertiesFromAnotherAccountModal = new bootstrap.Modal(document.getElementById('mergeAccounts'))
        mergePropertiesFromAnotherAccountModal.show()
        break
      case 'mergeAccountSelected':
        console.log('user_id, token :>> ', user_id, token);
        let loadMergeDetailsResults = await clientService.loadMergeDetails({ user_id: user_id, token: token })
        if (loadMergeDetailsResults.data.success) {
          console.log('loadMergeDetailsResults.data :>> ', loadMergeDetailsResults.data)
          $scope.mergePropertiesModalScope.properties = loadMergeDetailsResults.data.properties
          $scope.toggleMergeProperties()
          $scope.mergePropertiesModalScope.user_name = `${loadMergeDetailsResults.data.user.first_name}  ${loadMergeDetailsResults.data.user.last_name}`
          $scope.mergePropertiesModalScope.user_email = loadMergeDetailsResults.data.user.username
          $scope.mergePropertiesModalScope.user_id = loadMergeDetailsResults.data.user.id
          $scope.mergePropertiesModalScope.authorized_users = loadMergeDetailsResults.data.authorized_users || 0
          safeApply($scope)
        } else {
          console.log("ERROR", loadMergeDetailsResults.data);
        }
        break
      case 'mergeProperties':
        let mergeObj = {
          dest: { user_id: $scope.client.info.id },
          source_user_id: $scope.mergePropertiesModalScope.user_id,   // a full merge also moves this account's authorized users
          operator_id: $scope.user.initials,
          source_prop_ids: []
        }
        $scope.mergePropertiesModalScope.properties.map(item => {
          if (item.selected == true) mergeObj.source_prop_ids.push(item.id)
        })

        // console.log('mergeObj :>> ', mergeObj);
        // console.log('mergeObj :>> ', `(${mergeObj.source_prop_ids.join(", ")})`);

        let mergePropertiesToAccountResults = await clientService.mergePropertiesToAccount(mergeObj)
        if (mergePropertiesToAccountResults.data.success) {
          const moved = mergePropertiesToAccountResults.data.authorized_moved || 0
          toastr.success(`Properties have been merged successfully${moved ? ` - ${moved} authorized user${moved > 1 ? 's' : ''} moved to this account` : ''}`, "Properties Merged", { timeOut: 8000 })
          await loadClientDetails()
        } else {
          toastr.error("There was an error merging properties", "Error", { timeOut: 15000 })
        }
        break
    }
  }
  $scope.userSelectedMerge = (id, token) => {
    $scope.mergePropertiesFromAnotherAccount('mergeAccountSelected', id, token)
  }
  $scope.toggleMergeProperties = function () {
    $scope.mergePropertiesModalScope.allChecked = !$scope.mergePropertiesModalScope.allChecked
    $scope.mergePropertiesModalScope.properties.map(item => {
      item.selected = $scope.mergePropertiesModalScope.allChecked
    })
    $scope.mergePropertiesModalScope.allChecked = $scope.mergePropertiesModalScope.allChecked
  }
  $scope.checkMergeAllStatus = function (pm) {
    pm.selected = !pm.selected
    $scope.mergePropertiesModalScope.allChecked = true
    for (let i = 0; i < $scope.mergePropertiesModalScope.properties.length; i++) {
      if ($scope.mergePropertiesModalScope.properties[i].selected === false) {
        $scope.mergePropertiesModalScope.allChecked = false
        continue
      }
    }
    safeApply($scope)
  }
  // ----------------------------------------------------------------------------------------------------  
  // #endregion -- Merge Properties


  async function convertToPartner(user_id) {
    let convertToPartnerObj = {
      user_id: user_id,
      partner_info_obj: {
        email: $scope.client.info.email,
        fname: $scope.client.info.first_name,
        lname: $scope.client.info.last_name,
        photo: "",
        company: "",
        message: "",
        website: "",
        shortURL: "",
        promocode: "P".concat(user_id + 30000),
        telephone: ""
      }
    }
    let convertToPartnerResults = await clientService.convertToPartner(convertToPartnerObj)
    if (convertToPartnerResults.data.success) {
      toastr.success(`User '${$scope.client.info.first_name} ${$scope.client.info.last_name}' successfully converted to a Partner`, "Partner Updated", { timeOut: 5000 })
      loadClientDetails()
    } else {
      toastr.error("Error converting user to Partner", "Database Error!", { timeOut: 15000 })
    }
  }

  $scope.propertyActionButtonsState = (action, index) => {
    let p = $scope.client.properties[index]
    let complete = true
    $scope.issues = []
    switch (action) {
      case 'archive':
        if (p.auth_ptio == 1) {
          $scope.issues.push('We are authorized on the property, cannot Archive until authorization is removed.')
          return complete
        }
        break
      case 'cancel_service':
        if (p.edit_active_common) {
          $scope.issues.push('Cannot sent document while in EDIT Mode')
          return complete
        }
        // if (p.docs_current === null) {
        //   complete = false
        //   $scope.issues.push('There are NO active documents on file.')
        // }
        if (p.docs_current != null) {
          if (p.docs_current.type == 'cancel') {
            complete = false
            $scope.issues.push('The last signed documents have been cancelled')
          }
        }
        break
      case 'send_documents':  // Criteria for sending documents
        // return
        // Don't enable if in property is in edit mode
        if (p.edit_active_common) {
          $scope.issues.push('Cannot send documents while in EDIT Mode')
          return complete
        }

        if (p.docs_current != null) {
          if (p.docs_current.type == 'sign_up') {
            complete = false
            $scope.issues.push('There are active documents on file, cancel these first.')
          }
        }

        if (p.fee_structure_id == 9) {
          complete = false
          $scope.issues.push('Please select a Fee Structure')
        }


        if (p.owner_name.length < 5) {
          complete = false
          $scope.issues.push('Please enter the owners name')
        }
        if (p.owner_address.address && p.owner_address.address.length < 5) {
          complete = false
          $scope.issues.push('Please enter Owners mailing address')
        }
        if (p.owner_address.city.length < 2) {
          complete = false
          $scope.issues.push('Please enter Owners mailing city')
        }
        if (p.owner_address.state.length < 2) {
          complete = false
          $scope.issues.push('Please enter Owners mailing state')
        }
        if (p.owner_address.zip.length < 5) {
          complete = false
          $scope.issues.push('Please enter Owners mailing zip code')
        }
        // if (p.situs.num.length == 0) {
        //   complete = false
        //   $scope.issues.push('Please enter Subject Property Street Number')
        // }
        // if (p.situs.street.length < 3) {
        //   complete = false
        //   $scope.issues.push('Please enter Subject Property Street Name')
        // }
        if (p.cad_account.length < 2) {
          complete = false
          $scope.issues.push('Please enter Subject Property CAD Account Number')
        }
        break
    }
    return !complete
  }

  $scope.viewDocument = (url) => {
    $scope.route(url, { open_new_tab: true })
  }
  $scope.downloadDocument = (url) => {
    try {
      $scope.route(url, { open_new_tab: false })
      toastr.success("Document Download", "Success!", { timeOut: 5000 })
    } catch (error) {
      toastr.error("Error Downloading Document", "Failed!", { timeOut: 10000 })
    }
  }

  $scope.pandadocAPICall = async (document_id, index, action) => {
    console.log('document_id, index, action :>> ', document_id, index, action)
    switch (action) {
      case 'view_doc_audit_trial':
        view_doc_audit_trial(document_id, index, action)
        break
      case 'view_doc_details':
        view_doc_details(document_id, index, action)
        break
    }
  }

  async function view_doc_audit_trial(document_id, index, action) {
    $scope.documentModalContent = {
      situs: $scope.client.properties[index].address,
      cad_account: $scope.client.properties[index].cad_account,
      document_id: document_id,
      action: action,
      modal_title: 'Audit Trail <span style="font-size: .6em; font-style: italic;">(PandaDOC)</span>'
    }
    let viewDocumentAuditTrialModal = new bootstrap.Modal(document.getElementById('ViewDocumentInformationModal'))
    viewDocumentAuditTrialModal.show()
    let pandadocAPICallResult = await propertyService.pandadocAPICall({ document_id: document_id, action: action })

    console.log('pandadocAPICallResult :>> ', JSON.stringify(pandadocAPICallResult.data.data, null, 2));

    if (pandadocAPICallResult.data.success) {
      $scope.auditTrialDetails = pandadocAPICallResult.data.data
    } else {
      $scope.auditTrialDetails = null
      toastr.error(`Error: ${pandadocAPICallResult.data.error.message}`, "Error Retrieving Audit Trial Info!", { timeOut: 20000 })
    }
    safeApply($scope)
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl)
    })

    $scope.initPopovers()

    safeApply($scope)
  }

  async function view_doc_details(document_id, index, action) {
    $scope.documentModalContent = {
      situs: $scope.client.properties[index].address,
      cad_account: $scope.client.properties[index].cad_account,
      document_id: document_id,
      action: action,
      modal_title: 'Document Details <span style="font-size: .6em; font-style: italic;">(PandaDOC)</span>'
    }
    let ViewDocumentInformationModal = new bootstrap.Modal(document.getElementById('ViewDocumentInformationModal'))
    ViewDocumentInformationModal.show()
    let pandadocAPICallResult = await propertyService.pandadocAPICall({ document_id: document_id, action: action })
    // console.log('pandadocAPICallResult :>> ', pandadocAPICallResult);
    if (pandadocAPICallResult.data.success) {
      $scope.documentDetails = pandadocAPICallResult.data.data
    } else {
      $scope.documentDetails = null
      toastr.error(`Error: ${pandadocAPICallResult.data.error.message}`, "Error Retrieving Document Info!", { timeOut: 20000 })
    }
    // This component uses shadow DOM, so we need to inject styles into it
    const viewer = document.querySelector('andypf-json-viewer')
    if (viewer && viewer.shadowRoot) {
      const style = document.createElement('style')
      style.textContent = `
        div[data-level="0"] {
          max-height: 100% !important;
          max-height: 65dvh !important;
          overflow: hidden !important;
          overflow-y: auto !important;
        }`
      viewer.shadowRoot.appendChild(style);
    }
    safeApply($scope)
  }

  $scope.resendDocumentEmail = async (document_id, index) => {
    const user_id = $scope.client.info.id
    let resendDocumentEmailResult = await propertyService.resendDocumentEmail({ document_id: document_id, user_id: user_id, operator_id: $scope.user.initials })
    // console.log('resendDocumentEmailResult :>> ', resendDocumentEmailResult);    
    if (resendDocumentEmailResult.data.success) {
      toastr.success("Document Email Resent", "Success!", { timeOut: 15000 })
    } else {
      toastr.error(`Error: ${resendDocumentEmailResult.data.error.email_response.detail}`, "Error Resending Document Email!", { timeOut: 20000 })
    }
  }

  $scope.sendDocumentsEmail = async (doc_link_request, doc_set, index) => {
    const prop_id = $scope.client.properties[index].id
    const user_id = $scope.client.info.id
    let email_data = {
      'prop_id': prop_id,
      'document_url': doc_link_request,
      'document_set': doc_set
    }
    let sendDocumentsEmailResult = await propertyService.sendDocumentsEmail({ email_data: email_data, user_id: user_id, operator_id: $scope.user.initials })
    if (!sendDocumentsEmailResult.data.success) {
      toastr.error(`Error: ${sendDocumentsEmailResult.data.error.email_response.detail}`, "Error Sending Document Email!", { timeOut: 20000 })
      return
    }
    toastr.success("Document Email Sent", "Success!", { timeOut: 5000 })
    safeApply($scope)
  }

  $scope.propertyActionButtons = async (action, index) => {
    let url = ''
    let prop_id = $scope.client.properties[index].id
    let appeal_id = $scope.client.properties[index].appeal_current.id
    let smartcomp_id = $scope.client.properties[index].appeal_current.smartcomp_id
    let user_id = $scope.client.info.id
    let token = $scope.client.info.token
    let cad_account = $scope.client.properties[index].cad_account
    let tax_year = $scope.client.properties[index].appeal_current.tax_year
    let cad_code = $scope.client.properties[index].cad_code
    let co = company[$scope.client.info.business_source]  // Company Record see top of source

    switch (action) {
      case 'documents_send_email':
      case 'documents_get_url_only':
        // Open Modal to verify address, phone number, signer type and documents to send
        // OR Get URL only for sending via own email system
        verifyDocumentInfo(action, index)
        break

      case 'refresh_documents':
        console.log('refresh_documents');
        let loadDocumentInfoByPropertyResult = await clientService.loadDocumentInfoByProperty({ prop_id: prop_id })
        console.log('loadDocumentInfoByPropertyResult :>> ', loadDocumentInfoByPropertyResult);
        if (loadDocumentInfoByPropertyResult.data.success) {
          if (loadDocumentInfoByPropertyResult.data.data.docs_current != null) {
            $scope.client.properties[index].docs_current = loadDocumentInfoByPropertyResult.data.data.docs_current
            $scope.client.properties[index].docs_all = loadDocumentInfoByPropertyResult.data.data.docs_all
          }
        } else {

        }
        safeApply($scope)
        break
      case 'view_sla':
        url = $scope.client.properties[index].docs_current.doc_links.sla.url
        $scope.route(url, { open_new_tab: true })
        break
      case 'view_aoa':
        url = $scope.client.properties[index].docs_current.doc_links.aoa.url
        $scope.route(url, { open_new_tab: true })
        break
      case 'view_chd':
        url = $scope.client.properties[index].docs_current.doc_links.chd.url
        $scope.route(url, { open_new_tab: true })
        break
      case 'download_sla':
        url = $scope.client.properties[index].docs_current.doc_links.sla.mediaLink
        $scope.route(url, { open_new_tab: true })
        break
      case 'download_aoa':
        url = $scope.client.properties[index].docs_current.doc_links.aoa.mediaLink
        $scope.route(url, { open_new_tab: true })
        break
      case 'download_chd':
        url = $scope.client.properties[index].docs_current.doc_links.chd.mediaLink
        $scope.route(url, { open_new_tab: true })
        break
      case 'archive':
        console.log('$scope.client.properties[index] :>> ', $scope.client.properties[index]);
        if ($scope.propertyActionButtonsState(action, index) == true) {
          showPropertyActionButtonState(action, index)
        } else {
          swal.fire({
            title: 'Archive Property?',
            text: "You won't be able to undo this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Archive it!'
          }).then((result) => {
            if (result.isConfirmed) {
              archiveProperty(prop_id, appeal_id, index)
            }
          })
        }
        break
      case 'send_documents':
        verifyHellosignDocs(action, index)
        break
      case 'cancel_service':
        if ($scope.propertyActionButtonsState(action, index) == true) {
          showPropertyActionButtonState(action, index)
        } else {
          // cancel documents
          $scope.cancelServiceManager("showCancelOptions", index)
          console.log("*** cancel documents fired ***");
        }
        break
      case 'view_analysis':
        url = `https://analysis.propertytax.io/${appeal_id}`
        $scope.route(url, { open_new_tab: true })
        break
      case 'evidence_portal':
        url = `https://evidence.${co.route_url}/${user_id}/${token}/${prop_id}`
        $scope.route(url, { open_new_tab: true })
        break
      case 'cad_site':
        let cad = findCAD(cad_code)
        url = cad[0].prop_lookup_url
        url = url.replaceAll('%pid%', cad_account)
        url = url.replaceAll('%year%', tax_year)
        navigator.clipboard.writeText(cad_account)
        toastr.success("CAD Account Copied to Clipboard", "Success!", { timeOut: 5000 })
        $scope.route(url, { open_new_tab: true })
        break
    }
  }

  async function archiveProperty(prop_id, appeal_id, index) {
    let archivePropertyResult = await systemService.functionCall({ type: "archiveProperty", prop_id: prop_id, appeal_id: appeal_id })
    console.log('archivePropertyResult :>> ', archivePropertyResult);
    if (archivePropertyResult.data.success) {
      $scope.client.properties.splice(index, 1)
      toastr.success("Property was Archived", "Archive Property!", { timeOut: 5000 })
      safeApply($scope)
    } else {
      toastr.error("Unable to Archive Property", "Database Error!", { timeOut: 15000 })
    }
  }

  function findCAD(cad_code) {
    console.log('countyData :>> ', countyData);
    return countyData.filter(item => {
      return item.cad_code == cad_code
    })
  }

  $scope.updatePropertyCADSelection = function (property) {
    let cad = findCAD(property.cad_code)
    if (cad.length > 0) {
      property.county = cad[0].name
    }
  }

  // Adds ReplaceAll to string function:  "Hello???".replaceAll("?", "!");
  String.prototype.replaceAll = function (str1, str2, ignore) {
    return this.replace(new RegExp(str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"), (ignore ? "gi" : "g")), (typeof (str2) == "string") ? str2.replace(/\$/g, "$$$$") : str2);
  }

  $scope.cancelServiceManager = async (action, index) => {
    let p = $scope.client.properties[index]
    switch (action) {
      case 'showCancelOptions':
        $scope.cancelServiceInfo = {
          prop_index: index,
          address: p.situs.num + ' ' + p.situs.street,
          email_client: 'Yes',
          email_cad: 'No',
          withdraw_protest: 'No',
          reason: ''
        }
        cancelServiceOptions = new bootstrap.Modal(document.getElementById('cancelServiceOptions'))
        cancelServiceOptions.show()
        break
      case 'cancelService':
        // Full name of the CRM operator performing the cancellation - stamped into
        // the document comments as "By: [CRM User Name]"
        const crmUser = systemService.getUserObj() || {}
        const crmUserName = [crmUser.first_name, crmUser.last_name].filter(Boolean).join(' ').trim() || 'Unknown'
        let csObj = {
          user_id: $scope.client.info.id,
          business_source: $scope.client.info.business_source,
          prop_id: $scope.client.properties[$scope.cancelServiceInfo.prop_index].id,
          appeal_id: $scope.client.properties[$scope.cancelServiceInfo.prop_index].appeal_current.id,
          cad_code: $scope.client.properties[$scope.cancelServiceInfo.prop_index].cad_code,
          account: $scope.client.properties[$scope.cancelServiceInfo.prop_index].cad_account,
          reason_provided: $scope.cancelServiceInfo.reason,
          crm_user_name: crmUserName,
          email_client: ($scope.cancelServiceInfo.email_client == 'Yes' ? true : false),
          email_cad: ($scope.cancelServiceInfo.email_cad == 'Yes' ? true : false),
          withdraw_protest: ($scope.cancelServiceInfo.withdraw_protest == 'Yes' ? true : false),
        }
        cancelServiceOptions.hide()
        let cancelServiceResults = await propertyService.cancelService(csObj)
        if (cancelServiceResults.data.success) {
          toastr.success("The service has been cancelled, refreshing client and property data.", "Service Cancelled", { timeOut: 8000 })
          await loadClientDetails()
        } else {
          toastr.error("There was an error processing 'Cancel Service' request!", "Error", { timeOut: 15000 })
        }
        break
      case 'closeModal':
        cancelServiceOptions.hide()
        break
    }
  }


  function showPropertyActionButtonState(action, index) {
    let html = '<div style="border-top: 1px solid lightgray; border-bottom: 1px solid lightgray; padding: 15px 0 0 0;"><ul style="list-style: none;">'
    $scope.issues.map(issue => { html += `<li>${issue}</li>` })
    html += "</ul></div>"
    Swal.fire({
      title: `Please correct the following issues!`,
      icon: 'info',
      html: html,
      focusConfirm: false,
      confirmButtonText: `OK`
    })
  }

  // For new PandaDOC integration  
  function verifyDocumentInfo(action, index) {
    // if ($scope.propertyActionButtonsState(action, index) == true) {
    //   let html = '<div style="border-top: 1px solid lightgray; border-bottom: 1px solid lightgray; padding: 15px 0 0 0;"><ul style="list-style: none;">'
    //   $scope.issues.map(issue => { html += `<li>${issue}</li>` })
    //   html += "</ul></div>"
    //   Swal.fire({
    //     title: `Please correct the following issues!`,
    //     icon: 'info',
    //     html: html,
    //     focusConfirm: false,
    //     confirmButtonText: `OK`
    //   })
    // } else {
    switch (action) {
      case 'documents_send_email':
        modal_type = "email"
        break
      case 'documents_get_url_only':
        modal_type = "url"
        break
    }
    let prop = $scope.client.properties[index]
    sendHellosignDocs = new bootstrap.Modal(document.getElementById('sendHellosignDocs'))
    $scope.hellosignInfo = {
      modal_type: modal_type,
      url: null,
      prop_index: index,
      user_id: $scope.client.info.id,
      prop_id: prop.id,
      appeal_id: prop.appeal_current.id,
      phone_no: formatPhoneNumber($scope.client.profile.details.phone) || "",
      doc_type: 'gold',
      address: `${prop.situs.num} ${prop.situs.street}`,
      feeDescription: $scope.feeDescriptions.filter(item => item.id == prop.fee_structure_id)[0].name,
      expiry: prop.aoa_expires,
      individual_signing: "",
      document: {
        sla: true,
        aoa: true,
        chd: true
      }
    }
    sendHellosignDocs.show()
    // }
  }

  $scope.selectDeselectDocSelection = (action) => {
    $scope.hellosignInfo.document.sla = action
    $scope.hellosignInfo.document.aoa = action
    $scope.hellosignInfo.document.chd = action
  }


  $scope.hellosignModalManager = async (action, prop_index) => {
    switch (action) {
      case 'send':
        $scope.documents_processing = true
        safeApply($scope)

        console.log('$scope.hellosignInfo :>> ', $scope.hellosignInfo);
        let document_set = []
        if ($scope.hellosignInfo.document.sla) document_set.push('sla')
        if ($scope.hellosignInfo.document.chd) document_set.push('chd')
        if ($scope.hellosignInfo.document.aoa) document_set.push('aoa')

        let data = {
          'doc_set': document_set,
          'prop_id': $scope.hellosignInfo.prop_id,
          'owner_phone': $scope.hellosignInfo.phone_no,
          'aoa_expiry': $scope.hellosignInfo.expiry,
          'signer_auth': $scope.hellosignInfo.individual_signing,
          'request_type': $scope.hellosignInfo.modal_type
        }
        // let data2 = {
        //   user_id: $scope.client.info.id,
        //   prop_id: $scope.client.properties[prop_index].id,
        //   appeal_id: $scope.client.properties[prop_index].appeal_current.id,
        //   phone_no: $scope.hellosignInfo.phone_no
        // }

        console.log('data :>> ', data);
        console.log('$scope.hellosignInfo.modal_type :>> ', $scope.hellosignInfo.modal_type);

        $scope.documents_processing = true
        let createEsignatureDocumentResults = await propertyService.createEsignatureDocument(data)

        $scope.documents_processing = false
        if ($scope.hellosignInfo.modal_type == 'email') {
          sendHellosignDocs.hide()
        }
        safeApply($scope)

        if (!createEsignatureDocumentResults.data.success) {
          toastr.error("There was an error processing the documents: " + createEsignatureDocumentResults.error, "Error!", { timeOut: 15000 })
        } else {
          toastr.success("Documents have been processed.", "Success!", { timeOut: 15000 })
          if ($scope.hellosignInfo.modal_type == 'url') {
            $scope.hellosignInfo.url = createEsignatureDocumentResults.data.data.url
            safeApply($scope)
          }
          await loadClientDetails()
        }
        break
      case 'cancel':
        sendHellosignDocs.hide()
        break
    }
  }

  let propertyObjClone = []

  $scope.manage_user_action = async function (section, action, index) {
    if (section == 'prop_values') {
      let p = $scope.client.properties[index]
      switch (action) {
        case 'cancel':
          $scope.client.properties[index] = angular.copy(propertyObjClone[index])
          propertyObjClone[index] = null
          p.edit_active_prop_values = false
          break
        case 'edit':
          if (p.edit_active_common) {  // Disable edit if it's active, only allow 1 edit at a time
            p.edit_active_common = false
            $scope.client.properties[index] = angular.copy(propertyObjClone[index])
          }
          propertyObjClone[index] = angular.copy($scope.client.properties[index])
          p.edit_active_prop_values = true
          break
        case 'save':
          // save fields
          console.log('$scope.client.properties[index] :>> ', $scope.client.properties[index])
          p.edit_active_prop_values = false
          let updatePropertyValues = await propertyService.updatePropertyValues($scope.client.properties[index])
          if (updatePropertyValues.data.success) {
            toastr.success("Property Information Updated", "Success!", { timeOut: 5000 })
          } else {
            toastr.error("Property Information could not be saved", "Error!", { timeOut: 15000 })
          }
          // safeApply($scope)
          break
      }
    }
    if (section == 'property') {
      let p = $scope.client.properties[index]
      switch (action) {
        case 'cancel':
          $scope.client.properties[index] = angular.copy(propertyObjClone[index])
          propertyObjClone[index] = null
          p.edit_active_common = false
          break
        case 'edit':
          if (p.edit_active_prop_values) {  // Disable edit if it's active, only allow 1 edit at a time
            p.edit_active_prop_values = false
            propertyObjClone[index] = angular.copy($scope.client.properties[index])
          }
          propertyObjClone[index] = angular.copy($scope.client.properties[index])
          p.edit_active_common = true
          break
        case 'save':
          // save fields
          console.log('$scope.client.properties[index] :>> ', $scope.client.properties[index])
          p.edit_active_common = false
          let updatePropertyCommonResults = await propertyService.updatePropertyCommon($scope.client.properties[index])
          if (updatePropertyCommonResults.data.success) {
            toastr.success("Property Details Updated", "Success!", { timeOut: 5000 })
          } else {
            toastr.error("Property Details could not be saved", "Error!", { timeOut: 15000 })
          }
          // safeApply($scope)
          break
      }
    }
    if (section == 'info') {
      switch (action) {
        case 'cancel':
          $scope.client = angular.copy(userObjClone)
          userObjClone = null
          $scope.editmode_clientinfo = false
          break
        case 'edit':
          userObjClone = angular.copy($scope.client)
          $scope.editmode_clientinfo = true
          break
        case 'save':
          if ($scope.form_editClient && $scope.form_editClient.$invalid) {
            toastr.error("Client Details could not be saved. Please fix the invalid fields.", "Error!", { timeOut: 15000 })
            return
          }
          let updateClientDetailsResults = await clientService.updateClientDetails($scope.client)
          console.log('updateClientDetailsResults.data :>> ', updateClientDetailsResults.data);
          if (updateClientDetailsResults.data.success) {
            toastr.success("Client Details Updated", "Success!", { timeOut: 5000 })
          } else {
            toastr.error("Client Details could not be saved", "Error!", { timeOut: 15000 })
          }
          $scope.editmode_clientinfo = false
          safeApply($scope)
          break
      }
    }
  }

  //  user_type = 1 (propertytax.io user)
  //  user_type = 2(GRC TAX user)
  function userObjReset(user_type = 2) {
    $scope.client = {
      info: {
        user_type: 'owner',
        business_source: (user_type == 1) ? 'Residential' : 'grc_tax',
        first_name: '',
        last_name: '',
        email: '',
        send_welcome_email: false
      },
      record: {
        id: 0,
        token: ''
      },
      properties: null,
      profile: {
        details: {
          first_name: '',
          last_name: '',
          email: '',
          add1: 'd',
          add2: '',
          city: '',
          state: '',
          zip: '',
          phone: '',
          cell: ''
        },
        partner_info: {
          company: "",
          email: "",
          fname: "",
          lname: "Utley",
          message: "",
          photo: "",
          promocode: "",
          shortURL: "",
          telephone: "",
          visits: 0,
          website: ""
        }
      }
    }
  }

  $scope.setBusinessSource = function (business_source) {
    $scope.client.info.business_source = business_source
  }

  // Property Action Buttons ---------------------------------
  //#region - Property Action Buttons
  $scope.propertyActionButton = function (action, prop_index) {
    console.log('action, prop_index :>> ', action, prop_index)
    let url = null,
      userID = $scope.client.info.id,
      propID = $scope.client.properties[prop_index].id,
      address = `${$scope.client.properties[prop_index].situs.num} ${$scope.client.properties[prop_index].situs.street}`,
      uid = $scope.client.properties[prop_index].prop_uid,
      firebaseID = $scope.client.info.token
    switch (action) {
      case "incrementReportCounter":
        Swal.fire({
          title: `Add reports to Property<br>${address}`,
          icon: 'question',
          showCancelButton: true,
          input: 'range',
          inputLabel: 'Increment Report Counter by:',
          inputAttributes: { min: 1, max: 10, step: 1 },
          inputValue: 5
        }).then((swal_result) => {
          if (swal_result.value) {
            dashboardService.incrementReportCounter(userID, propID, { qty: swal_result.value })
              .then(result => {
                if (result.data.result == "Success") {
                  $scope.manage_user_panel.user_info.properties[prop_index].max_reports = result.data.data.max_reports
                  toastr.success(`Max Report Count increased by ${swal_result.value} for a total of ${result.data.data.max_reports}`, 'Increment Max Report Counter', { timeOut: 3000 })
                } else {
                  toastr.error("Error increasing Max Reports", 'Increment Max Report Counter', { timeOut: 3000 })
                  console.log("Error:", result.data)
                }
                console.log('result :>> ', result);
              })
          }
        })
        break
      case 'archiveProperty':
        Swal.fire({
          title: 'Are you sure?',
          html: `You are about to archive this property<br><strong>${address}</strong>`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Archive It!'
        }).then((result) => {
          if (result.isConfirmed) {
            // dashboardService.archiveProperty(userID, propID, {})
            //   .then(result => {
            //     if (result.data.result == "Success") {
            //       toastr.success(`Property has been archived`, 'Archive Property', { timeOut: 3000 })
            //       $scope.manage_user_panel.user_info.properties.splice(prop_index, 1)
            //     } else {
            //       toastr.error("Error Archiving Property", 'Archive Property', { timeOut: 3000 })
            //       console.log("Error:", result.data)
            //     }
            //   })
          }
        })
        break
    }
  }
  // END: Property Action Buttons ---------------------------------
  //#endregion - Property Action Buttons

  function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
  }

  // prop_id comes from a Tax ID (#) or Prop ID (@) search - open the client on that property's card
  $scope.clientSearchSelected = (id, token, prop_id) => {
    if (prop_id) routePropId = String(prop_id)

    if ($scope.client === null) {
      $scope.client = { record: { id: id, token: token } }
    } else {
      $scope.client.record.id = id
      $scope.client.record.token = token
    }
    loadClientDetails()
  }

  //--------------------------------------------------------
  //#region - Add Manual Property

  let autocompleteOutOfBounds

  $scope.copySitusToMailing = () => {
    $scope.outboundproperty.owner.address = `${$scope.outboundproperty.situs.num} ${$scope.outboundproperty.situs.street}`
    $scope.outboundproperty.owner.city = $scope.outboundproperty.situs.city
    $scope.outboundproperty.owner.zip = $scope.outboundproperty.situs.zip
    $scope.outboundproperty.owner.state = $scope.outboundproperty.situs.state
  }

  $scope.initGoogleSearchOutOfBounds = () => {
    autocompleteOutOfBounds = new google.maps.places.Autocomplete((document.getElementById('SearchOutOfBounds')), { types: ['address'], componentRestrictions: { country: "US" } })
    autocompleteOutOfBounds.addListener('place_changed', function () {
      console.log("************************************");
      $scope.subOutOfBoundsAddressSearch('outOfBounds')
    })
    $("body").trigger("resize")
  }

  $scope.subOutOfBoundsAddressSearch = async (type) => {
    var place = autocompleteOutOfBounds.getPlace() || undefined
    console.log('place :>> ', place);
    if (place.formatted_address === undefined) {
      return
    }
    let googleSearchObj = searchService.convertGoogleResponseToObject(place)
    console.log('googleSearchObj :>> ', googleSearchObj);
    $scope.outboundproperty.situs = {
      num: googleSearchObj.street_number.short_name,
      street: googleSearchObj.street_name.short_name,
      city: googleSearchObj.city.long_name,
      zip: googleSearchObj.zip.short_name,
      state: 'TX'
    }
    $scope.outboundproperty.formatted_address = googleSearchObj.formatted_address
    $scope.getGeoDataFromAddress()
  }

  $scope.saveOutOfBoundsProperty = async () => {
    console.log('saveOutOfBoundsProperty called')
    const cad_code = $scope.selectedCounty?.manual_entry
      ? $scope.outboundproperty.actual_cad_code
      : $scope.selectedCounty.cad_code

    let obj = { ...$scope.outboundproperty, user_id: $scope.client.info.id, cad_code: cad_code }
    // console.log('obj :>> ', obj)

    addPropertyModal.hide()
    let addOutOfBoundsPropertyToAccountResult = await propertyService.addOutOfBoundsPropertyToAccount(obj)
    if (addOutOfBoundsPropertyToAccountResult.data.success) {
      $scope.client.properties = addOutOfBoundsPropertyToAccountResult.data.data
      toastr.success("Property added to account", "Property Added!", { timeOut: 5000 })
    } else {
      toastr.error("There was an error adding Property", "Property Error!", { timeOut: 15000 })
    }
    safeApply($scope)
  }

  $scope.getGeoDataFromAddress = async () => {
    let address = `${$scope.outboundproperty.situs.num} ${$scope.outboundproperty.situs.street}, ${$scope.outboundproperty.situs.city} ${$scope.outboundproperty.situs.zip} ${$scope.outboundproperty.situs.state}`
    console.log('address :>> ', address);
    let getGeoDataFromAddressResult = await systemService.functionCall({ type: "getGeoDataFromAddress", address: address })
    console.log('getGeoDataFromAddressResult :>> ', getGeoDataFromAddressResult)
    if (getGeoDataFromAddressResult.data.success) {
      $scope.outboundproperty.geo_location = { lat: getGeoDataFromAddressResult.data.data.geometry.location.lat, lng: getGeoDataFromAddressResult.data.data.geometry.location.lng }
    } else {
      $scope.outboundproperty.geo_location = { lat: '', lng: '' }
    }
    safeApply($scope)
  }

  $scope.updateFormattedAddress = () => {
    $scope.outboundproperty.formatted_address = `${$scope.outboundproperty.situs.num} ${$scope.outboundproperty.situs.street}, ${$scope.outboundproperty.situs.city}, ${$scope.outboundproperty.situs.state} ${$scope.outboundproperty.situs.zip}`
  }

  $scope.outboundproperty = {
    situs: { num: '', street: '', city: '', zip: '', state: 'TX', legal: [], parcel: '' },
    owner: { name: '', address: '', city: '', zip: '', state: 'TX' },
    geo_location: { lat: '', lng: '' },
    actual_cad_code: '',
    type: 'RES',
    formatted_address: '',
    entry_method: 'manual',
    cad_account: '',
    show_google_search: true,
    return_properties: true,
    tax_year: $rootScope.tax_year
  }

  $scope.isSitusComplete = () => {
    return $scope.outboundproperty.situs.num.length > 0 && $scope.outboundproperty.situs.street.length > 0 && $scope.outboundproperty.situs.city.length > 0 && $scope.outboundproperty.situs.zip.length >= 5
  }

  $scope.resetSitus = () => {
    $scope.outboundproperty.situs = { num: '', street: '', city: '', zip: '', state: '' }
    $scope.outboundproperty.show_google_search = true
    $scope.outboundproperty.actual_cad_code = ''
    focusSearchOutOfBounds()
  }

  function focusSearchOutOfBounds() {
    setTimeout(() => {
      $('#SearchOutOfBounds').val('').focus()
    }, 100)
  }

  //#endregion - Add Manual Property
  //--------------------------------------------------------

  //--------------------------------------------------------
  //#region - Add Property
  $scope.propertySelected = async (prop_index) => {
    addPropertyModal.hide()
    let obj = {
      user_id: $scope.client.info.id,
      cad_code: $scope.searchObj.properties[prop_index].cad_code,
      cad_account: $scope.searchObj.properties[prop_index].account,
      return_properties: true
    }

    let addPropertyToAccountResult = await propertyService.addPropertyToAccount(obj)
    if (addPropertyToAccountResult.data.success) {
      $scope.client.properties = addPropertyToAccountResult.data.data
      toastr.success("Property added to account", "Property Added!", { timeOut: 5000 })
    } else {
      toastr.error("There was an error adding Property", "Property Error!", { timeOut: 15000 })
    }
    safeApply($scope)
    console.log('$scope.client.properties :>> ', $scope.client.properties);
  }

  $scope.addProperty = function (type, action, comment_index, prop_index) {
    addPropertyModal = new bootstrap.Modal(document.getElementById('addPropertyModal'))
    resetSearchObj()
    $scope.searchInProgress = true
    $scope.allCountyList = searchService.getCountyList()
    $scope.outboundproperty.actual_cad_code = ''

    $scope.mappedCountyList = $scope.allCountyList.filter(item => item.mapped_data == 1)

    console.log("allCountyList", $scope.allCountyList)
    $scope.selectedCounty = { name: "", cad_code: '000' }
    addPropertyModal.show()
  }

  $scope.importProperties = function () {
    importPropertiesModal = new bootstrap.Modal(document.getElementById('importPropertiesModal'))
    $scope.importPropertiesForm = { cad_code: getDefaultImportPropertyCadCode(), fee_structure_id: null, cad_accounts_text: '', validated: false, processing: false, properties: [] }
    importPropertiesModal.show()
  }

  $scope.setCounty = function (countyKey) {
    resetSearchObj()
    if (countyKey === -1) {
      $scope.selectedCounty = { name: "Enter Manually", cad_code: '000', active: 0, manual_entry: true }
    } else {
      const selectedCounty = $scope.allCountyList.find(county => county.cad_code == countyKey)
      if (!selectedCounty) {
        $scope.selectedCounty = { name: "", cad_code: '000' }
        return
      }

      $scope.selectedCounty = selectedCounty
      $scope.outboundproperty.actual_cad_code = ''
    }
    $scope.searchInProgress = true
    if ($scope.selectedCounty.active == 1) {
      setTimeout(() => {
        $('#autocomplete').val('').focus()
      }, 0)
    }
  }

  $scope.saveProperty = function () {
    addPropertyModal.hide()
  }

  $scope.initGoogleSearch = () => {
    autocomplete = new google.maps.places.Autocomplete((document.getElementById('autocomplete')), { types: ['address'], componentRestrictions: { country: "US" } })
    autocomplete.addListener('place_changed', function () {
      $scope.subAddressSearch('addSearch_google')
    })
    $("body").trigger("resize")
  }

  $scope.subAddressSearch = async function (type) {
    let obj
    $scope.searchInProgress = true
    if (type == 'addSearch_google') {
      var place = autocomplete.getPlace() || undefined
      if (place.formatted_address === undefined) {
        $scope.resetSearch()
        return
      }
      let googleSearchObj = searchService.convertGoogleResponseToObject(place)
      let searchObj = angular.copy(googleSearchObj)
      obj = {
        type: 'addSearch_google',
        cad_code: searchObj.cad_code,
        full_address: searchObj.formatted_address,
        situs_num: searchObj.street_number.short_name,
        situs_street: searchObj.street_name.short_name
      }
    } else if (type == 'addSearch_propid') {
      obj = {
        type: 'addSearch_propid',
        uid: `${$scope.selectedCounty.cad_code}${$scope.propIDInput}`
      }
    }
    let getPropUIDResults = await searchService.getPropUID(obj)
    if (getPropUIDResults.data.data.length > 0) {
      console.log("GOOD");
      $scope.searchObj.properties = getPropUIDResults.data.data
      $scope.searchObj.property_found = true
    } else {
      console.log("Prop not found");
      $scope.searchObj.properties = null //[{ prop_uid: "", full_address: "", owner_name: "", account: "", division: "" }]
      $scope.searchObj.property_found = false
    }
    $scope.searchInProgress = false
    safeApply($scope)
    console.log('$scope.searchObj :>> ', $scope.searchObj);
  }

  function resetSearchObj() {
    $scope.searchObj = {
      google_search: null,
      county: { name: "Select County", cad_code: "" },
      address: { number: "", street: "" },
      properties: null,
      // properties    : [{  prop_uid    : "",
      //                     full_address: "",
      //                     owner_name  : "",
      //                     division    : "",
      //                     account     : ""
      //                   }],
      property_found: false,
    }
    $scope.searchInProgress = false
  }

  $scope.clearSearch = function () {
    resetSearchObj()
    $scope.searchInProgress = true
    setTimeout(() => {
      $('#autocomplete').val('').focus()
    }, 500);
  }

  $scope.propIDSearch = function () {
    setTimeout(() => {
      $('#propIdSearchInput').val('').focus()
    }, 500);
  }

  //#endregion - Add Property
  //--------------------------------------------------------

  //-------------------------------------------------------
  //#region - View Email History
  $scope.emails = []
  $scope.activeMessage = -1
  $scope.messageLoading = false
  $scope.email_events = { year: 0, years: [], report_options: [] }

  $scope.emailHistory = async function (action, email_index) {
    switch (action) {
      case 'openModal':
        $scope.activeMessage = -1
        $scope.opensMenu = { open: false, m: null, top: 0, left: 0 }
        let emailHistory = await clientService.getEmailHistory({ user_id: $scope.client.info.id })
        if (emailHistory.data.success) {
          $scope.emails = emailHistory.data.data
        } else {
          $scope.emails = []
        }
        console.log('$scope.emails :>> ', JSON.stringify($scope.emails[0], null, 2));
        emailHistoryModal = new bootstrap.Modal(document.getElementById('viewEmailHistoryModal'))
        emailHistoryModal.show()
        safeApply($scope)
        break
      case 'viewEmail':
        $scope.activeMessage = email_index
        load_active_message()
        break
      case 'print':
        const formattedDate = $filter('date')($scope.msg.date, "medium");
        const mywindow = window.open('', 'PRINT', 'height=800,width=660')
        const header = `<div style="text-align:center"><h3 style="line-height: 1; padding: 0; margin:0;">${$scope.msg.subject}</h3><h5 style="line-height:1; padding:0; margin: 8px 0 0 0;">${formattedDate}</h5 ></div > `
        mywindow.document.write(header)
        mywindow.document.write($scope.msg.msg)
        mywindow.document.close()
        mywindow.focus()
        mywindow.print()
        break
      case 'getEventHistory':
        $scope.email_events = { year: 0, years: [], report_options: [] }
        for (let i = 0; i < 4; i++) $scope.email_events.years.push(new Date().getFullYear() - i)
        $scope.email_events.year = $scope.email_events.years[0]
        $scope.email_events.report_options = [
          { title: 'Notification of Auth / Appeal', start: 3000, end: 3999 },
          { title: 'Notification of Value', start: 2000, end: 2899 },
          { title: 'Notification Past Due', start: 2900, end: 2999 },
        ]
        console.log('$scope.email_events :>> ', $scope.email_events);
        safeApply($scope)
        break
      case 'loadEventHistory':
        const report_year = $('#report_year').val()
        const report_type = $('#report_type').val()
        let eventHistory = await clientService.loadEmailEvents({
          user_id: $scope.client.info.id,
          tax_year: report_year,
          event: 'open',
          email_id_start: $scope.email_events.report_options[report_type].start,
          email_id_end: $scope.email_events.report_options[report_type].end
        })
        $scope.email_events.eventHistory = eventHistory.data.data
        safeApply($scope)
        break
      case 'copyEventHistoryReport':
        let copyText = ''
        if ($scope.email_events.eventHistory.length > 0) {
          let emailID = -1 // $scope.email_events.eventHistory[0].email_id
          $scope.email_events.eventHistory.forEach((event) => {
            const formattedDate = $filter('date')(event.opened, "medium");
            if (emailID != event.email_id) {
              copyText += `\n\n• Email ID: ${event.email_id} - ${event.subject}\n\t Opened: `
              copyText += `  ${formattedDate}, `
              emailID = event.email_id
            } else {
              copyText += `  ${formattedDate}, `
            }
          })
        } else {
          copyText = 'No events found'
        }
        console.log(copyText);
        navigator.clipboard.writeText(copyText);
        break
    }
  }

  async function load_active_message() {
    $scope.messageLoading = true

    let getMsg = { url: $scope.emails[$scope.activeMessage].email_url }

    let loadMessageResults = await clientService.loadMessage(getMsg)

    console.log('loadMessageResults :>> ', loadMessageResults);

    $scope.msg = {
      id: $scope.emails[$scope.activeMessage].id,                        // z_email_log id - Download / Resend
      email_subject: $scope.emails[$scope.activeMessage].email_subject,  // list title - PDF file name
      msg: loadMessageResults.data.data,
      subject: $scope.emails[$scope.activeMessage].subject,
      tax_year: $scope.emails[$scope.activeMessage].tax_year,
      date: $scope.emails[$scope.activeMessage].sent || '',
      delivery_method: $scope.emails[$scope.activeMessage].delivery_method   // 'usps' = printed mail piece
    }
    console.log('$scope.msg :>> ', $scope.msg);
    $scope.messageLoading = false
    safeApply($scope)
    // A mailed letter is shown as its printed sheets - runs once ng-bind-html has put it in the DOM
    setTimeout(() => MailerCopy.layout(document.querySelector('#viewEmailHistoryModal .eh-preview-frame')), 0)
  }

  // Download the open email / mail piece as a PDF, named {title}_{client name}.pdf.
  // Emails are rendered server-side by DocRaptor; postal mail returns the PDF that was actually printed.
  $scope.emailPdfDownloading = false
  $scope.downloadEmailPdf = async () => {
    if (!$scope.msg?.id || $scope.emailPdfDownloading) return
    $scope.emailPdfDownloading = true
    safeApply($scope)
    try {
      const result = await clientService.emailHistoryPdf({ email_log_id: $scope.msg.id, user_id: $scope.client.info.id })
      if (!result?.data?.success) throw new Error(result?.data?.error || 'PDF failed')
      const bytes = Uint8Array.from(atob(result.data.data), c => c.charCodeAt(0))
      const blob = new Blob([bytes], { type: 'application/pdf' })
      const clean = s => `${s || ''}`.trim().replace(/[\\/:*?"<>|]+/g, '').replace(/\s+/g, '_')
      const name = clean(`${$scope.client.info.first_name || ''} ${$scope.client.info.last_name || ''}`)
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `${clean($scope.msg.email_subject || $scope.msg.subject) || 'email'}_${name || $scope.client.info.id}.pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      setTimeout(() => URL.revokeObjectURL(link.href), 1000)
    } catch (error) {
      console.log('downloadEmailPdf error :>> ', error)
      toastr.error($scope.msg.delivery_method == 'usps' ? 'The printed PDF for this mail piece could not be found.' : 'Could not create the PDF.', 'Download', { timeOut: 8000 })
    } finally {
      $scope.emailPdfDownloading = false
      safeApply($scope)
    }
  }

  // Opens history (hamburger on each email card in the list) + a copy formatted for pasting into Intercom.
  // The menu is position:fixed at the clicked button so the scrolling list can't clip it.
  $scope.emailOpens = { loading: false, tracked: true, opens: [], error: null }
  $scope.opensMenu = { open: false, m: null, top: 0, left: 0 }

  $scope.toggleOpensMenu = ($event, m) => {
    $event.stopPropagation()   // don't also select the card
    if ($scope.opensMenu.open && $scope.opensMenu.m === m) return $scope.closeOpensMenu()
    const rect = $event.currentTarget.getBoundingClientRect()
    const width = 460   // matches the menu's width in details.html
    $scope.opensMenu = {
      open: true,
      m: m,
      top: rect.bottom + 4,
      left: Math.max(8, Math.min(rect.left, window.innerWidth - width - 8))
    }
    $scope.loadEmailOpens(m)
  }
  $scope.closeOpensMenu = () => {
    $scope.opensMenu.open = false
    safeApply($scope)
  }
  // click anywhere outside the menu, or scroll the list, closes it
  const opensMenuOutsideClick = (e) => {
    if ($scope.opensMenu.open && !e.target.closest('.eh-opens-menu, .eh-opens-btn')) $scope.closeOpensMenu()
  }
  const opensMenuListScroll = (e) => {
    if ($scope.opensMenu.open && e.target.closest && e.target.closest('.eh-message-list')) $scope.closeOpensMenu()
  }
  document.addEventListener('mousedown', opensMenuOutsideClick)
  document.addEventListener('scroll', opensMenuListScroll, true)
  $scope.$on('$destroy', () => {
    document.removeEventListener('mousedown', opensMenuOutsideClick)
    document.removeEventListener('scroll', opensMenuListScroll, true)
  })

  $scope.loadEmailOpens = async (m) => {
    if (!m?.id) return
    $scope.emailOpens = { loading: true, tracked: true, opens: [], error: null }
    safeApply($scope)
    try {
      const result = await clientService.getEmailOpens({ email_log_id: m.id, user_id: $scope.client.info.id })
      if ($scope.opensMenu.m !== m) return   // menu moved to another card while this was loading
      if (!result?.data?.success) throw new Error(result?.data?.error || 'Opens failed')
      $scope.emailOpens = { loading: false, tracked: result.data.data.tracked, opens: result.data.data.opens || [], error: null }
    } catch (error) {
      console.log('loadEmailOpens error :>> ', error)
      $scope.emailOpens = { loading: false, tracked: true, opens: [], error: 'Could not load the open history.' }
    }
    safeApply($scope)
  }

  $scope.copyEmailOpens = async () => {
    const fmt = d => $filter('date')(d, "MMM d, yyyy 'at' h:mm a")
    const fmtOpen = d => $filter('date')(d, 'MMM d, yyyy h:mm:ss a')   // same as the popout
    const m = $scope.opensMenu.m
    const subject = (m.parameters && m.parameters.subject) || m.email_subject || ''
    const opens = $scope.emailOpens.opens
    const summary = !$scope.emailOpens.tracked
      ? 'Open tracking is not available for this message.'
      : opens.length ? `Opened ${opens.length} time${opens.length == 1 ? '' : 's'}:` : 'No opens have been recorded yet.'
    const esc = s => `${s || ''}`.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

    const text = [`Email: ${subject}`, `Sent: ${fmt(m.sent)}`, '', summary]
      .concat(opens.map(o => `• ${fmtOpen(o.opened)} - Email ID ${o.email_id} - IP ${o.ip || 'unknown'}`)).join('\n')
    const html = `<p><b>Email:</b> ${esc(subject)}<br><b>Sent:</b> ${esc(fmt(m.sent))}</p><p>${esc(summary)}</p>`
      + (opens.length ? `<ul>${opens.map(o => `<li>${esc(fmtOpen(o.opened))} - Email ID ${esc(o.email_id)} - IP ${esc(o.ip || 'unknown')}</li>`).join('')}</ul>` : '')

    try {
      // rich text keeps the bold labels + bullets when pasted into Intercom; plain text is the fallback
      if (window.ClipboardItem && navigator.clipboard?.write && window.isSecureContext) {
        await navigator.clipboard.write([new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([text], { type: 'text/plain' })
        })])
      } else {
        await copyTextToClipboard(text)
      }
      toastr.success('Open history copied - paste it into Intercom.', 'Copied!', { timeOut: 4000 })
    } catch (error) {
      toastr.error('Could not copy the open history.', 'Failed!', { timeOut: 8000 })
    }
  }

  // Resend the open email: owner + active additional emails, each toggleable, plus extra CCs
  let resendEmailModal
  $scope.resend = { recipients: [], newCc: '', sending: false }

  $scope.openResendModal = async () => {
    if (!$scope.msg?.id) return
    const info = $scope.client.info
    const recipients = []
    if (info.email) recipients.push({ email: info.email, label: `${info.first_name || ''} ${info.last_name || ''}`.trim() + ' (Account Owner)', selected: true })
    try {
      const result = await clientService.getAdditionalEmails({ user_id: info.id })
      if (result?.data?.success) {
        result.data.data
          .filter(e => e.active == 1 && e.email)
          .forEach(e => recipients.push({ email: e.email, label: `${e.first_name || ''} ${e.last_name || ''}`.trim() + ' (Additional Email)', selected: true }))
      }
    } catch (error) {
      console.log('openResendModal additional emails error :>> ', error)
      toastr.warning('Additional emails could not be loaded.', 'Resend', { timeOut: 6000 })
    }
    $scope.resend = { recipients: recipients, newCc: '', sending: false }
    resendEmailModal = resendEmailModal || new bootstrap.Modal(document.getElementById('resendEmailModal'))
    resendEmailModal.show()
    // sits above the Email History modal - lift the backdrop Bootstrap just added above it too
    setTimeout(() => $('.modal-backdrop').last().css('z-index', 10020), 0)
    safeApply($scope)
  }

  $scope.resendSelectedCount = () => $scope.resend.recipients.filter(r => r.selected).length

  $scope.addResendCc = () => {
    const email = `${$scope.resend.newCc || ''}`.trim()
    if (!isValidEmail(email)) {
      toastr.error('Please enter a valid email address.', 'Resend')
      return
    }
    const existing = $scope.resend.recipients.find(r => r.email.toLowerCase() === email.toLowerCase())
    if (existing) existing.selected = true
    else $scope.resend.recipients.push({ email: email, label: 'Additional CC', selected: true, extra: true })
    $scope.resend.newCc = ''
  }

  $scope.removeResendCc = (index) => {
    $scope.resend.recipients.splice(index, 1)
  }

  $scope.sendResend = async () => {
    const selected = $scope.resend.recipients.filter(r => r.selected).map(r => r.email)
    if (!selected.length || $scope.resend.sending) return
    $scope.resend.sending = true
    $scope.user = systemService.getUserObj($scope.user)
    try {
      const result = await clientService.resendEmail({
        email_log_id: $scope.msg.id,
        user_id: $scope.client.info.id,
        recipients: selected,
        sent_by: { id: $scope.user?.id, initials: $scope.user?.initials, name: `${$scope.user?.first_name || ''} ${$scope.user?.last_name || ''}`.trim() }
      })
      if (!result?.data?.success) throw new Error(result?.data?.error || 'Resend failed')
      toastr.success(`Email resent to ${selected.length} recipient${selected.length == 1 ? '' : 's'}.`, 'Resend', { timeOut: 6000 })
      // the resend is a new row at the top of the list (newest first) - reload and keep the open message selected
      const history = await clientService.getEmailHistory({ user_id: $scope.client.info.id })
      if (history?.data?.success) {
        const openId = $scope.msg.id
        $scope.emails = history.data.data
        $scope.activeMessage = $scope.emails.findIndex(m => m.id == openId)
      }
      const sentComment = result.data.data && result.data.data.comment
      if (sentComment) {
        if (!$scope.client.info.comments) $scope.client.info.comments = []
        $scope.client.info.comments.unshift(sentComment)
      }
      resendEmailModal.hide()
    } catch (error) {
      console.log('sendResend error :>> ', error)
      toastr.error('Email was NOT resent.', 'Resend', { timeOut: 10000 })
    } finally {
      $scope.resend.sending = false
      safeApply($scope)
    }
  }

  // async function load_active_message() {
  //   $scope.messageLoading = true
  //   let getMsg = $scope.emails[$scope.activeMessage].parameters
  //   getMsg.update_db = false
  //   getMsg.send_email = false
  //   getMsg.test_mode = false
  //   getMsg.is_preview = true
  //   getMsg.sent_less_than = 999999
  //   let loadMessageResults = await clientService.loadMessage(getMsg)
  //   console.log('loadMessageResults :>> ', loadMessageResults);
  //   $scope.msg = {
  //     msg: loadMessageResults.data.data.data.email_template,
  //     subject: getMsg.subject,
  //     tax_year: getMsg.tax_year,
  //     date: $scope.emails[$scope.activeMessage].sent || ''
  //   }
  //   console.log('$scope.msg :>> ', $scope.msg);
  //   $scope.messageLoading = false
  //   safeApply($scope)
  // }

  //#endregion - View Email History
  //--------------------------------------------------------

  //-------------------------------------------------------
  //#region - Send Email Modal
  let createEmail
  let emailBodyEditorReady = false

  function normalizeEmailBody(content) {
    const normalizedContent = String(content || '').trim()
    if (!normalizedContent || normalizedContent === '<p><br></p>' || normalizedContent === '<br>') {
      return ''
    }
    return normalizedContent
  }

  function setEmailBodyEditorContent(content) {
    const normalizedContent = normalizeEmailBody(content)
    const emailBodyElement = $('#email_body')
    if (!emailBodyElement.length) return

    if (emailBodyEditorReady && $.fn.summernote) {
      emailBodyElement.summernote('code', normalizedContent)
    } else {
      emailBodyElement.val(normalizedContent)
    }

    $scope.email.body = normalizedContent
  }

  function syncEmailBodyFromEditor() {
    const emailBodyElement = $('#email_body')
    if (emailBodyEditorReady && emailBodyElement.length && $.fn.summernote) {
      $scope.email.body = normalizeEmailBody(emailBodyElement.summernote('code'))
    }
    return $scope.email.body || ''
  }

  function initializeEmailBodyEditor() {
    const emailBodyElement = $('#email_body')
    if (!emailBodyElement.length || !$.fn.summernote) return

    if (!emailBodyEditorReady) {
      emailBodyElement.summernote({
        placeholder: 'Compose email...',
        tabsize: 2,
        height: 460,
        dialogsInBody: true,
        toolbar: [
          ['style', ['style']],
          ['font', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
          ['fontname', ['fontname']],
          ['fontsize', ['fontsize']],
          ['color', ['color']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['insert', ['link', 'table', 'hr']],
          ['view', ['codeview', 'fullscreen']],
        ],
        fontSizes: ['8', '9', '10', '11', '12', '14', '16', '18', '24', '36'],
        callbacks: {
          onChange: function (contents) {
            $scope.email.body = normalizeEmailBody(contents)
            safeApply($scope)
          },
        },
      })
      emailBodyEditorReady = true
      initializeEmailSnippetDragDrop()
    }

    setEmailBodyEditorContent($scope.email?.body || '')
  }

  // Drag the "copy" items in the left column straight into the editor. Summernote's own
  // dropzone overlay covers the editor and pastes at the last caret, so it is hidden while a
  // snippet is dragged and the drop is placed at the pointer with a visible drop caret.
  const EMAIL_SNIPPET_TYPE = 'application/x-crm-email-snippet'
  let emailSnippetDragging = false

  function emailSnippetHtml(text) {
    return String(text || '')
      .replace(/\s+$/, '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/ *\n/g, '<br>')
  }

  function caretRangeAtPoint(x, y) {
    if (document.caretPositionFromPoint) {
      const pos = document.caretPositionFromPoint(x, y)
      if (!pos || !pos.offsetNode) return null
      const rng = document.createRange()
      rng.setStart(pos.offsetNode, pos.offset)
      rng.collapse(true)
      return rng
    }
    return document.caretRangeFromPoint ? document.caretRangeFromPoint(x, y) : null
  }

  function caretRectForRange(rng) {
    const rect = rng.getClientRects()[0]
    if (rect && rect.height) return rect
    // Collapsed ranges in empty blocks (<p><br></p>) have no client rect - use the block's edge
    let node = rng.startContainer
    if (node.nodeType === 1 && node.childNodes[rng.startOffset]?.nodeType === 1) {
      node = node.childNodes[rng.startOffset]
    }
    if (node.nodeType !== 1) node = node.parentNode
    const box = node.getBoundingClientRect()
    return { left: box.left, top: box.top, height: Math.min(box.height || 18, 22) }
  }

  function initializeEmailSnippetDragDrop() {
    const $modal = $('#createEmail')
    const $editor = $('#email_body').next('.note-editor')
    const $editingArea = $editor.find('.note-editing-area')
    const editable = $editor.find('.note-editable')[0]
    if (!$modal.length || !editable) return

    const $caret = $('<div class="email-drop-caret" aria-hidden="true"></div>').appendTo($editingArea)

    function hideCaret() {
      $caret.removeClass('is-visible')
    }

    function endDrag() {
      emailSnippetDragging = false
      hideCaret()
      $modal.removeClass('email-snippet-dragging')
      $editor.removeClass('email-drop-target')
      $modal.find('.email_copy_item.is-dragging').removeClass('is-dragging')
    }

    function rangeInsideEditor(e) {
      const rng = caretRangeAtPoint(e.clientX, e.clientY)
      return rng && editable.contains(rng.startContainer) ? rng : null
    }

    $modal.off('.emailSnippet')
      .on('dragstart.emailSnippet', '.email_copy_item', function (e) {
        const dt = e.originalEvent.dataTransfer
        const text = String(this.getAttribute('data-clipboard-text') || '')
        if (!dt || !text.trim()) {
          e.preventDefault()
          return
        }
        const html = emailSnippetHtml(text)
        dt.effectAllowed = 'copy'
        dt.setData(EMAIL_SNIPPET_TYPE, html)
        dt.setData('text/plain', text.replace(/\s+$/, ''))

        const title = $(this).find('.email_copy_item__title').text().trim()
        const $ghost = $('<div class="email-snippet-drag-ghost"></div>')
          .append($('<div class="email-snippet-drag-ghost__title"></div>').text(title))
          .append($('<div class="email-snippet-drag-ghost__body"></div>').html(html))
          .appendTo(document.body)
        if (dt.setDragImage) dt.setDragImage($ghost[0], 14, 14)
        setTimeout(() => $ghost.remove(), 0)

        emailSnippetDragging = true
        $(this).addClass('is-dragging')
        $modal.addClass('email-snippet-dragging')
      })
      .on('dragend.emailSnippet', '.email_copy_item', endDrag)

    $(editable).off('.emailSnippet')
      .on('dragover.emailSnippet', function (e) {
        if (!emailSnippetDragging) return
        e.preventDefault()
        e.originalEvent.dataTransfer.dropEffect = 'copy'
        $editor.addClass('email-drop-target')

        const rng = rangeInsideEditor(e.originalEvent)
        if (!rng) return hideCaret()
        const rect = caretRectForRange(rng)
        const areaBox = $editingArea[0].getBoundingClientRect()
        $caret
          .css({ left: rect.left - areaBox.left - 1, top: rect.top - areaBox.top, height: rect.height })
          .addClass('is-visible')
      })
      .on('dragleave.emailSnippet', function (e) {
        if (!emailSnippetDragging || editable.contains(e.relatedTarget)) return
        $editor.removeClass('email-drop-target')
        hideCaret()
      })
      .on('drop.emailSnippet', function (e) {
        if (!emailSnippetDragging) return
        // let it bubble so Summernote's document handler clears its own dragover state
        e.preventDefault()
        const html = e.originalEvent.dataTransfer.getData(EMAIL_SNIPPET_TYPE)
        const rng = rangeInsideEditor(e.originalEvent)
        endDrag()
        if (!html) return

        editable.focus()
        if (rng) {
          const sel = window.getSelection()
          sel.removeAllRanges()
          sel.addRange(rng)
        }
        const $body = $('#email_body')
        $body.summernote('editor.setLastRange')
        $body.summernote('pasteHTML', html)
        $scope.email.body = normalizeEmailBody($body.summernote('code'))
        safeApply($scope)
      })
  }

  function refreshEmailSnippets() {
    $scope.sendEmail('getSalutation')
    $scope.sendEmail('getRegards')
    $scope.sendEmail('getAllPropsList')
  }

  $scope.sendEmail = async function (action, prop_index) {
    $scope.user = systemService.getUserObj($scope.user)
    switch (action) {
      case 'send':
        let emailObj = {
          to: 'bryanutley2000@yahoo.com', //$scope.client.info.email,
          business_source: $scope.client.info.business_source,
          cc: $scope.email.cc ? $scope.email.cc : null,
          bcc: $scope.email.bcc ? $scope.email.bcc : null,
          subject: $scope.email.subject,
          body: syncEmailBodyFromEditor(),
          tax_year: $rootScope.tax_year,
          user_id: $scope.client.info.id,
          sent_by: { id: $scope.user?.id, initials: $scope.user?.initials, name: `${$scope.user?.first_name || ''} ${$scope.user?.last_name || ''}`.trim() }
        }
        console.log('emailObj :>> ', emailObj)
        try {
          let _results = await clientService.sendEmailViaTemplate(emailObj)
          console.log('_results :>> ', _results)
          if (_results.data.success) {
            toastr.success("Email was sent successfully!", "Client Email", { timeOut: 8000 })
            const sentComment = _results.data.data && _results.data.data.comment
            if (sentComment) {
              if (!$scope.client.info.comments) $scope.client.info.comments = []
              $scope.client.info.comments.unshift(sentComment)
              safeApply($scope)
            }
          } else {
            toastr.error("Email was NOT successful!", "Client Email", { timeOut: 10000 })
          }
        } catch (error) {
          console.log('sendEmail error :>> ', error)
          toastr.error("Email request failed before completion.", "Client Email", { timeOut: 10000 })
        }
        break
      case 'cancel':
        $scope.email = { subject: '', cc: null, bcc: null, body: '' }
        $scope.activeProperty = { id: $scope.client.properties[0].id, data: $scope.client.properties[0] }
        setEmailBodyEditorContent('')
        break
      case 'create':
        $scope.email = { subject: '', cc: null, bcc: null, body: '' }
        createEmail = new bootstrap.Modal(document.getElementById('createEmail'))
        $scope.activeProperty = { id: $scope.client.properties[0].id, data: $scope.client.properties[0] }
        // Salutation / Regards / Properties List are built lazily on click - build them up front
        // so they can be dragged without clicking first
        refreshEmailSnippets()
        createEmail.show()
        setTimeout(() => {
          initializeEmailBodyEditor()
        }, 150)
        safeApply($scope)
        break
      case 'setActiveProperty':
        $scope.activeProperty = { id: $scope.client.properties[prop_index].id, data: $scope.client.properties[prop_index] }
        safeApply($scope)
        break
      case 'getAllPropsList':
        $scope.allPropsList = ''
        $scope.client.properties.forEach(prop => {
          $scope.allPropsList += `• ${prop.situs.num} ${prop.situs.street} \n`
        })
        $scope.allPropsList = $sce.trustAsHtml($scope.allPropsList)
        safeApply($scope)
        break
      case 'getRegards':
        $scope.regards = $sce.trustAsHtml(`Regards, \n${$scope.user.first_name} ${$scope.user.last_name} `)
        safeApply($scope)
        break
      case 'getSalutation':
        $scope.salutation = $sce.trustAsHtml(`Hello ${$scope.client.info.first_name}, \n\n`)
        safeApply($scope)
        break
    }
  }
  //#endregion - Send Email Modal
  //--------------------------------------------------------

  //-------------------------------------------------------
  //#region - Comment Manager Modal
  let enterComment, situs
  $scope.commentManager = async function (type, action, comment_index, prop_index) {
    enterComment = new bootstrap.Modal(document.getElementById('enterComment'))
    console.log('type, action, comment_index, prop_index :>> ', type, action, comment_index, prop_index)
    $scope.comment = { type: type, action: action, comment_index: comment_index, prop_index: prop_index }
    if (action == 'insert') {
      $scope.comment.comment = ""
      $scope.comment.rec_id = -1
      if (type == 'property') {
        situs = $scope.client.properties[prop_index].situs
        $scope.comment.address = `${situs.num} ${situs.street} `
      }
    }
    else if (action == 'update') {
      if (type == 'client') {
        $scope.comment.rec_id = $scope.client.info.comments[$scope.comment.comment_index].id
        $scope.comment.comment = $scope.client.info.comments[$scope.comment.comment_index].comment
      }
      else if (type == 'property') {
        situs = $scope.client.properties[prop_index].situs
        $scope.comment.rec_id = $scope.client.properties[prop_index].comments[comment_index].id
        $scope.comment.comment = $scope.client.properties[prop_index].comments[comment_index].comment
        $scope.comment.address = `${situs.num} ${situs.street} `
      }
    }
    else if (action == 'delete') {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to UNDO this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          if (type == 'client') {
            $scope.comment.rec_id = $scope.client.info.comments[$scope.comment.comment_index].id
          }
          else if (type == 'property') {
            $scope.comment.rec_id = $scope.client.properties[prop_index].comments[comment_index].id
          }
          $scope.commentInsertUpdateDelete('delete')
          return
        }
      })
      return
    }
    enterComment.show()
  }

  // Reload the client's comments (e.g. a reply comment the API added since the client was opened)
  $scope.commentsRefreshing = false
  $scope.refreshClientComments = async function () {
    if ($scope.commentsRefreshing || !$scope.client || !$scope.client.info) return
    $scope.commentsRefreshing = true
    safeApply($scope)
    try {
      const result = await clientService.commentsManager({ action: 'list', related_to_type: 'client', related_to_record: $scope.client.info.id })
      if (result.data.result !== 'Success') throw new Error(result.data.error || 'Unable to load comments')
      $scope.client.info.comments = result.data.data || []
    } catch (error) {
      console.log('refreshClientComments error :>> ', error)
      toastr.error('Could not refresh comments', 'Comments', { timeOut: 6000 })
    }
    $scope.commentsRefreshing = false
    safeApply($scope)
  }

  // Comments and Emails tabs: plain comments go to commentRows, sent emails and their replies to emailRows.
  // An email and its replies stay together. A conversation sits where its newest comment is (so a new reply
  // brings it to the top); inside it the sent email comes first, then the replies oldest to newest.
  // Rows are rebuilt whenever the comments array changes.
  $scope.commentRows = []
  $scope.emailRows = []
  $scope.commentCounts = { comments: 0, emails: 0 }

  const commentThreadId = (c) => {
    const ref = $scope.commentEmailRef(c)
    return (ref && ref.thread_id) || c.email_thread_id || null
  }

  function buildCommentRows() {
    const list = ($scope.client && $scope.client.info && $scope.client.info.comments) || []
    const groups = []
    const byThread = {}
    list.forEach((c) => {   // newest first
      const threadId = commentThreadId(c)
      if (!threadId) { groups.push({ items: [c] }); return }
      if (!byThread[threadId]) { byThread[threadId] = { threadId, items: [] }; groups.push(byThread[threadId]) }
      byThread[threadId].items.push(c)
    })

    const rows = []
    groups.forEach((g) => {
      if (!g.threadId) {
        rows.push({ c: g.items[0], kind: $scope.commentEmailRef(g.items[0]) ? 'email' : 'comment' })
        return
      }
      const isSent = (c) => !!($scope.commentEmailRef(c) && $scope.commentEmailRef(c).thread_id)
      const ordered = g.items.filter(isSent).concat(g.items.filter((c) => !isSent(c)).sort((a, b) => a.id - b.id))
      ordered.forEach((c, i) => rows.push({
        c, kind: 'email', threadId: g.threadId,
        first: i === 0, last: i === ordered.length - 1, child: i > 0, grouped: ordered.length > 1
      }))
    })

    $scope.commentRows = rows.filter((r) => r.kind === 'comment')
    $scope.emailRows = rows.filter((r) => r.kind === 'email')
    $scope.commentCounts = { comments: $scope.commentRows.length, emails: $scope.emailRows.length }
  }

  $scope.$watchCollection('client.info.comments', buildCommentRows)

  // Action from Modal - Save, Update, Delete
  $scope.commentInsertUpdateDelete = function (action) {
    let comment_obj
    if (action == 'insert_update') {
      enterComment.hide()
      comment_obj = {
        action: $scope.comment.action,
        comment: $scope.comment.comment,
        entered_by: $scope.user.initials,
        related_to_record: ($scope.comment.type == 'client') ? $scope.client.info.id : $scope.client.properties[$scope.comment.prop_index].id,
        related_to_type: $scope.comment.type,
        rec_id: $scope.comment.rec_id,
        comment_index: $scope.comment.comment_index,
        prop_index: $scope.comment.prop_index
      }
    }
    else if (action == 'delete') {
      comment_obj = { action: 'delete', comment_index: $scope.comment.comment_index, prop_index: $scope.comment.prop_index, rec_id: $scope.comment.rec_id, related_to_type: $scope.comment.type }
    }

    clientService.commentsManager(comment_obj)
      .then(result => {
        if (comment_obj.action == 'insert') {
          if (comment_obj.related_to_type == 'client') {
            $scope.client.info.comments.splice(0, 0, result.data.data)
          }
          else if (comment_obj.related_to_type == 'property') {
            if ($scope.client.properties[comment_obj.prop_index].comments == null) {
              $scope.client.properties[comment_obj.prop_index].comments = []
            }
            $scope.client.properties[comment_obj.prop_index].comments.unshift(result.data.data)
          }
        }
        else if (comment_obj.action == 'update') {
          if (comment_obj.related_to_type == 'client') {
            $scope.client.info.comments[comment_obj.comment_index].comment = comment_obj.comment
          }
          else if (comment_obj.related_to_type == 'property') {
            $scope.client.properties[comment_obj.prop_index].comments[comment_obj.comment_index].comment = comment_obj.comment
          }
        }
        else if (comment_obj.action == 'delete') {
          if (comment_obj.related_to_type == 'client') {
            $scope.client.info.comments.splice(comment_obj.comment_index, 1)
          }
          else if (comment_obj.related_to_type == 'property') {
            $scope.client.properties[comment_obj.prop_index].comments.splice(comment_obj.comment_index, 1)
          }
        }
        $scope.comment = null
        comment_obj = null
        enterComment.hide()
        safeApply($scope)
      })
  }
  //#endregion - Comment Manager Modal
  //--------------------------------------------------------

  //--------------------------------------------------------
  //#region - Email Conversation Modal
  /*
    Comments for CRM emails carry a link: <a class="crm-email-link crm-email-thread-<id>"> (the sent email) or
    crm-email-reply-<id> (a reply, added by the API's Inbound Parse webhook). Clicking one opens the sent email and
    every reply. Early comments used href="#crm-email-..." instead - still handled.
    Email HTML renders in a sandboxed iframe (no scripts, no same-origin) so reply markup can't touch the CRM.
  */
  const CONVERSATION_MODAL_ID = 'email_conversation_modal'
  const CONVERSATION_FRAME_ID = 'email_conversation_frame'
  let conversationModal = null

  $scope.conversation = { loading: false, error: null, thread: null, replies: [], selected: 'sent', view: 'html' }

  // Capture phase: runs before Angular's html5Mode link handling, so the #hash never becomes a route change.
  // clientController is also on the Add New panel (both are on the page at once) - only act on links in this view.
  function onCrmEmailLinkClick(event) {
    const link = event.target && event.target.closest ? event.target.closest('a.crm-email-link, a[href^="#crm-email-"]') : null
    if (!link || !$element[0].contains(link)) return
    event.preventDefault()
    event.stopPropagation()
    const match = `${link.className} ${link.getAttribute('href') || ''}`.match(/crm-email-(thread|reply)-([0-9]+)/)
    if (!match) return
    $scope.openEmailConversation(match[1] === 'thread' ? { thread_id: Number(match[2]) } : { reply_id: Number(match[2]) })
  }
  document.addEventListener('click', onCrmEmailLinkClick, true)

  function getConversationModal() {
    if (!conversationModal) conversationModal = bootstrap.Modal.getOrCreateInstance($element[0].querySelector(`#${CONVERSATION_MODAL_ID}`))
    return conversationModal
  }

  const escapeEmailHtml = (value) => String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c])

  // <base target="_blank"> sends links in the email to a new tab instead of navigating the frame
  function buildEmailDocument(bodyHtml) {
    return `<!doctype html>
<html>
<head>
  <meta charset="utf-8">
  <base target="_blank">
  <style>
    body { margin: 14px 18px; font-family: Poppins, Arial, Helvetica, sans-serif; font-size: 14px; line-height: 1.5; color: #1f2933; word-wrap: break-word; }
    img { max-width: 100%; height: auto; }
    p { margin: 0 0 8px; }
    blockquote { border-left: 3px solid #d4dae3; margin: 8px 0; padding: 2px 0 2px 12px; color: #6c757d; }
    pre.ec-text { white-space: pre-wrap; font-family: inherit; margin: 0; }
    .ec-missing { color: #8a94a6; font-style: italic; }
    a { color: #2b9cd3; }
  </style>
</head>
<body>${bodyHtml}</body>
</html>`
  }

  $scope.selectedConversationItem = () => {
    const c = $scope.conversation
    if (c.selected === 'sent') return null
    return c.replies[c.selected] || null
  }

  function renderConversationFrame() {
    const c = $scope.conversation
    let body
    if (c.selected === 'sent') {
      body = c.thread && c.thread.metadata && c.thread.metadata.body
        ? c.thread.metadata.body
        : '<p class="ec-missing">The body of this email was not saved (it was sent before the CRM started keeping a copy).</p>'
    } else {
      const reply = $scope.selectedConversationItem()
      body = reply && reply.html_body
        ? reply.html_body
        : `<pre class="ec-text">${escapeEmailHtml((reply && reply.text_body) || '(this email has no content)')}</pre>`
    }
    // wait for the modal DOM / ng-show to settle
    setTimeout(() => {
      const frame = document.getElementById(CONVERSATION_FRAME_ID)
      if (frame) frame.srcdoc = buildEmailDocument(body)
    }, 0)
  }

  $scope.selectConversationItem = (key) => {
    const c = $scope.conversation
    c.selected = key
    const reply = $scope.selectedConversationItem()
    c.view = (reply && !reply.html_body) ? 'text' : 'html'
    renderConversationFrame()
    // Opening a new reply is what "reading" it means (same as System Tools > Emails Received)
    if (reply && reply.status === 'new') {
      emailRepliesService.updateStatus({ id: reply.id, status: 'read' })
        .then((result) => { if (result.data.success) { reply.status = 'read'; safeApply($scope) } })
        .catch((error) => console.log('conversation mark read failed :>> ', error))
    }
  }

  $scope.setConversationView = (view) => {
    $scope.conversation.view = view
    if (view === 'html') renderConversationFrame()
  }

  $scope.openEmailConversation = async (params) => {
    $scope.conversation = { loading: true, error: null, thread: null, replies: [], selected: 'sent', view: 'html' }
    getConversationModal().show()
    safeApply($scope)
    try {
      const result = await clientService.getEmailConversation(params)
      if (!result.data.success) throw new Error(result.data.error || 'Unable to load this email')
      const data = result.data.data
      $scope.conversation.thread = data.thread
      $scope.conversation.replies = data.replies || []
      $scope.conversation.loading = false
      const focusIndex = data.focus_reply_id ? $scope.conversation.replies.findIndex((r) => r.id === data.focus_reply_id) : -1
      $scope.selectConversationItem(focusIndex >= 0 ? focusIndex : 'sent')
    } catch (error) {
      console.log('openEmailConversation error :>> ', error)
      $scope.conversation.loading = false
      $scope.conversation.error = error.message
    }
    safeApply($scope)
  }

  $scope.closeEmailConversation = () => { if (conversationModal) conversationModal.hide() }

  // { thread_id } | { reply_id } for a comment written for a CRM email (sent or reply received), else null
  $scope.commentEmailRef = (c) => {
    if (!c || !c.comment) return null
    if (c.$emailRefFor !== c.comment) {
      const match = String(c.comment).match(/crm-email-(thread|reply)-([0-9]+)/)
      c.$emailRef = match ? (match[1] === 'thread' ? { thread_id: Number(match[2]) } : { reply_id: Number(match[2]) }) : null
      c.$emailRefFor = c.comment
    }
    return c.$emailRef
  }

  // Reply from a comment: open the Email Sender with "Re: <subject>" and the email quoted under 3 blank lines.
  // Reply HTML comes from outside, so it goes through $sanitize (drops scripts, event handlers, <style>) first.
  $scope.replyToCommentEmail = async (c) => {
    const ref = $scope.commentEmailRef(c)
    if (!ref || c.$replyLoading) return
    c.$replyLoading = true
    safeApply($scope)
    try {
      const result = await clientService.getEmailConversation(ref)
      if (!result.data.success) throw new Error(result.data.error || 'Unable to load this email')
      const { thread, replies, focus_reply_id } = result.data.data
      const reply = focus_reply_id ? (replies || []).find((r) => r.id === focus_reply_id) : null

      let quoted, when, who, subject
      if (reply) {
        quoted = reply.html_body ? reply.html_body : escapeEmailHtml(reply.text_body || '').replace(/\r?\n/g, '<br>')
        when = reply.received_at
        who = reply.from_name ? `${escapeEmailHtml(reply.from_name)} &lt;${escapeEmailHtml(reply.from_email)}&gt;` : escapeEmailHtml(reply.from_email || 'the client')
        subject = reply.subject || thread.subject || ''
      } else {
        quoted = (thread.metadata && thread.metadata.body) || ''
        when = thread.created_at
        const from = (thread.metadata && thread.metadata.from) || {}
        who = escapeEmailHtml(from.name || thread.sent_from || 'we')
        subject = thread.subject || ''
      }

      let safeQuoted = ''
      try { safeQuoted = $sanitize(quoted) } catch (error) { safeQuoted = escapeEmailHtml(quoted) }
      const dateText = when ? moment(when).format('ddd, MMM D, YYYY [at] h:mm A') : ''
      const blank = '<p><br></p>'
      const body = `${blank}${blank}${blank}` +
        `<p>On ${dateText}, ${who} wrote:</p>` +
        `<blockquote style="margin: 0 0 0 6px; padding-left: 10px; border-left: 3px solid #d4dae3; color: #555;">${safeQuoted || '<i>(no content)</i>'}</blockquote>`

      // Opens the modal and schedules the editor, which loads $scope.email.body - so set it right after
      $scope.sendEmail('create')
      $scope.email.subject = /^re:/i.test(subject.trim()) ? subject.trim() : `Re: ${subject.trim()}`
      $scope.email.body = body
      // The editor already exists after the first open: push the content in directly as well
      setTimeout(() => setEmailBodyEditorContent(body), 200)
    } catch (error) {
      console.log('replyToCommentEmail error :>> ', error)
      toastr.error(error.message || 'Unable to load this email', 'Reply', { timeOut: 8000 })
    }
    c.$replyLoading = false
    safeApply($scope)
  }

  $scope.emailAddressDisplay = (name, email) => (name ? `${name} <${email}>` : (email || '—'))

  $scope.$on('$destroy', () => {
    document.removeEventListener('click', onCrmEmailLinkClick, true)
    if (conversationModal) {
      conversationModal.hide()
      conversationModal.dispose()
      conversationModal = null
    }
  })
  //#endregion - Email Conversation Modal
  //--------------------------------------------------------

})

